// 酒店七大类图标（icon / icon1 / icon2）统一用 2026-09 改版的线框图标，见 src/assets/img/category/
// （和 src/icons/svg/ 的同名文件是同一份，改图标两边一起改）。变量名沿用旧图片的名字，指向的已是新图标
import Group1 from "@/assets/img/category/sun.svg";
import Group2 from "@/assets/img/category/clean.svg";
import Group3 from "@/assets/img/category/bed.svg";
import Group4 from "@/assets/img/category/location.svg";
import Group5 from "@/assets/img/category/food.svg";
import Group6 from "@/assets/img/category/money.svg";
import Group7 from "@/assets/img/category/services.svg";
import Group1_1 from "@/assets/img/category/location.svg";
import Group2_1 from "@/assets/img/category/clean.svg";
import Group3_1 from "@/assets/img/category/bed.svg";
import Group4_1 from "@/assets/img/category/sun.svg";
import Group5_1 from "@/assets/img/category/services.svg";
import Group6_1 from "@/assets/img/category/food.svg";
import Group7_1 from "@/assets/img/category/money.svg";
import icon_FB from "@/assets/img/category/food.svg";
import icon_Amenities from "@/assets/img/category/sun.svg";
import icon_Cleanness from "@/assets/img/category/clean.svg";
import icon_Location from "@/assets/img/category/location.svg";
import icon_Room from "@/assets/img/category/bed.svg";
import icon_Service from "@/assets/img/category/services.svg";
import icon_Value from "@/assets/img/category/money.svg";
import img_english from "@/assets/img/img_english.png"
import img_chinese from "@/assets/img/img_chinese.png"
import img_German from "@/assets/img/img_German.png"
import img_Italian from "@/assets/img/img_Italian.png"
import icon_Brand from "@/assets/img/icon_Brand.png";
import Group8_1 from "@/assets/img/Group8_1.png";
import icon_Brand1 from "@/assets/img/icon_Brand1.png";
import global from '@/assets/img/global.png'
import APAC from '@/assets/img/APAC.png'
import CHINA from '@/assets/img/CHINA.png'
import EMEA from '@/assets/img/EMEA.png'
import N_A from '@/assets/img/N_A.png'
import MIDDLE_EAST from '@/assets/img/MIDDLE_EAST.png'
import AFRICA from '@/assets/img/AFRICA.png'
import SOUTH_AMERICA from '@/assets/img/SOUTH_AMERICA.png'
// 餐厅六大类同样换成 2026-09 的线框图标（src/assets/img/category/icon_*.svg，和 src/icons/svg/ 同名文件是同一份）
import Food_Quality from '@/assets/img/category/icon_Food_Quality.svg'
import Beverage_Quality from '@/assets/img/category/icon_Beverage_Quality.svg'
import Service_Quality from '@/assets/img/category/icon_Service_Quality.svg'
import Ambience from '@/assets/img/category/icon_Ambience.svg'
import Value_For_Money from '@/assets/img/category/icon_Value_For_Money.svg'
import Cleanliness from '@/assets/img/category/icon_Cleanliness.svg'
export default {
    // 模块加载状态（components/common/ModuleLoadState.vue）
    ModuleLoad: {
        loading: '加载中…',
        slow: '加载时间较长',
        failed: '加载失败',
        retry: '重试',
    },
    countryArr:[
        {
            name:'中文',
            value:'zh',
            icon:img_chinese
        },
        {
            name:'English',
            value:'en',
            icon:img_english
        },
        // {
        //     name:'意大利语',
        //     value:'it',
        //     icon:img_Italian
        // },
        {
            name:'Deutsch',
            value:'de',
            icon:img_German
        },
    ],
    message: {
        coming_soon:'即将推出',
        language: '中文',
        gmb:'Where to know Insights 有限责任公司出品',
        Settings_saved:'设置已保存',
        CurrentPassword:"当前密码不能为空",
        CurrentPassword1:"密码确认与新密码不匹配",
        CurrentPassword2:"密码已更改",
        sidebar:"已成功注销",
        competitors:'请先选择酒店',
        competitors1:'服务器错误，请稍后再试。',
        DateTimePickerHome: '结束日期不能超过当前日期',
        DateTimePickerHome1: '无法加载酒店，请重试。',
        DateTimePickerHome2: '至少选择一个平台',
        platformOverview: '文件上传成功',
        platformOverview1: '文件大小不能超过5MB',
        platformOverview2: '请先上传文件',
        login:'请输入您的用户名和密码',
        login1:"登录成功",
        login2:"登录失败，用户名或密码不正确",
        login3:"登录请求失败，请稍后再试",
        Reviews:"目前没有评论，请重新筛选",
        Reviews1:"您的登录已过期,立即登录。",
        Reviews2:"服务器错误,请稍后再试",
        Reviews3:"网络错误,请稍后再试",
        Exporting:"正在导出，请稍候...",
        Download_ready:"下载完成",
        Export_failed:"导出失败",
        Export_no_evidence:"已导出，但不含评论证据——你没有评论查看权限",
        AI:"原始内容不能为空，也不能翻译",
        AI1:"翻译接口返回异常，请再试一次",
        AI2:"翻译失败，请检查您的网络或重试",
        AI3:"已复制到剪贴板",
        AI4:"复制失败，请再试一次",
        AI5:"发送成功",
        AI6:"无翻译内容",
        AI7:"未获得目标语言，请再试一次",
        AI8:"翻译失败，请再试一次",
        AI9:"先生，请把原文写下来",
        AI10:"正在处理，请稍后操作",
        AI11:"请先选择翻译语言",
        AI12:"无法获取新的AI内容",
        FilterContainer:"筛选条件已应用",
        FilterContainer1:"应用程序操作已取消",
        onlyTrans:'请选择语言',
        ReplyResponeRate:'至少需要选择一个平台',
        LikeSuccess:'该评论回复已收藏，稍后请到回复模版界面查看。',
        LikeTooltip:'请先点击生成',
        noLikeSuccess:'取消收藏成功',
        requestFailed:'请求失败，请重试。',
        noLikeTooltip:'取消收藏',
        Saved_successfully:'现已保存',
        Notes_saved:'笔记已保存',
        Removed_from_Reply_Library:'从回复库中移除',
        Couldn_remove_from_Reply_Library:"无法从回复库中删除",
    },
    sidebar: {
        replayGuide: '重新查看引导',
        language: '语言',
        // 侧边栏 New 胶囊、品牌模式里拼出来的菜单名（集团名 / 品牌名是数据，只翻译固定部分）
        newBadge:'新',
        groupOverview:'{group} 概览',
        thailandLuxuryOverview:'泰国奢华酒店概览',
        brandDetails:'{brand} 详情',
    },
    // 标题复用现有 menu 翻译（见 menuKey），只有描述文案是新增的，避免和侧边栏本身的
    // 标签文案脱节。
    sidebarGuide: {
        skip: '跳过',
        prev: '上一步',
        next: '下一步',
        finish: '完成',
        steps: {
            hotelSelector: { title: '切换酒店', desc: '点击酒店名称，可以在你管理的所有门店之间快速切换。' },
            moduleSwitch: { title: '酒店/餐厅模式', desc: '在酒店和餐厅两种视图之间切换，各自有独立的看板和菜单。' },
            aiChat: { desc: '用自然语言提问，即时获得基于真实数据的酒店经营洞察。' },
            overview: { desc: '酒店首页：各平台评分、回复率、最新评论和需要关注的问题一目了然。' },
            reviews: { desc: '查看并回复每一条住客评价，跟进重点案例，管理你的回复模板。' },
            competition: { desc: '对比周边竞对酒店在各 OTA 平台的评分和评价表现。' },
            insights: { desc: '更深入的报表和品牌层面总览，帮你发现跨门店的趋势。' },
            surveys: { desc: '通过自定义问卷收集住客在住店期间和离店后的反馈。' },
            restaurantSelector: { title: '切换餐厅', desc: '点击餐厅名称，可以在你管理的各家餐厅之间切换。' },
            restaurantAiChat: { desc: '用自然语言提问，马上得到基于数据的餐厅表现分析。' },
            restaurantOverview: { desc: '餐厅首页：各平台评分、回复率、最新评论、各项得分，以及员工和菜品被提到的情况。' },
            restaurantReviews: { desc: '查看并回复每一条客人评论，跟进标记的问题，管理回复设置和回复模板。' },
            restaurantCompetition: { desc: '在各平台评分和评论上与周边餐厅对比。' },
            restaurantInsights: { desc: '月度报告和更长周期的餐厅表现回顾。' },
            generals: { desc: '管理账号设置，在帮助中心查找常见问题解答。' },
        },
    },
    // 新手导览名称（Help Center「Replay guide」列表，见 utils/guideTours.js）
    guideTours: {
        sidebar: '侧边栏导航',
        home: '酒店首页',
        reviews: '评论',
        restaurantReviews: '餐饮评论',
        restaurantSidebar: '侧边栏导航',
        restaurantHome: '餐厅首页',
        skip: '跳过',
        prev: '上一步',
        next: '下一步',
        finish: '完成',
    },
    restaurantHomeGuide: {
        steps: {
            platforms: { title: '平台概览', desc: '每个平台的评分、回复率和平均回复时间，以及要升到目标分大概还需要多少条满分评论。' },
            activity: { title: '最新动态和上月榜单', desc: '「{recent}」显示最近 72 小时的评论，切换 Type 可以看客人夸了什么、抱怨了什么；「{topLists}」列出上个月被提到最多的优点和问题。' },
            filters: { title: '平台和时间范围', desc: '选择平台和时间范围，下面所有分数和榜单都会跟着更新。' },
            scores: { title: '各项得分', desc: '总分和餐食、饮品、服务等各项得分。鼠标放到眼睛图标上看好评 / 中评 / 差评数量，点击看下面的细分类别。' },
            attention: { title: '{areasWarning}', desc: '正在拉低分数的细分类别；全部表现良好时这里是空的。' },
            competitors: { title: '竞品对比', desc: '你的总分和所关注竞品的对比。' },
            mentions: { title: '员工和菜品提及', desc: '客人最常提到的员工、菜品和饮品，以及好评占比；点一行可以看相关评论。' },
        },
    },
    reviewsGuide: {
        steps: {
            period: { title: '时间范围', desc: '选时间范围或具体日期，下面的平台卡和评论列表会一起更新。' },
            tools: { title: '搜索、筛选和导出', desc: '搜索评论内容、切换列表样式，按分数、评论类型、情绪、类别筛选，或导出当前看到的评论。' },
            platforms: { title: '平台', desc: '每张卡显示该平台在所选时间内的均分和评论数；点卡片可以显示或隐藏这个平台的评论。' },
            card: { title: '评论详情', desc: '每张卡片是一条评论。「{mismatch}」这类标签提示值得细看的评论，「{goTo}」打开原文；点「{expand}」看完整分析，下面就展开这一条。' },
            score: { title: 'WQI 分数', desc: '根据客人写的内容由 AI 打出的 1–10 分（5 分制平台已换算）。鼠标移上去可以看各分数段的颜色。' },
            translate: { title: '翻译', desc: '选择语言翻译这条评论，也可以在译文和原文之间切换。' },
            guestTags: { title: '客人标签', desc: '「{guestTags}」是客人在平台上发评论时自己选的信息，比如餐食、服务、氛围的分项评分，用餐人数、噪音程度等；在筛选里可以按这些条件筛选评论。' },
            analysis: { title: 'AI 分析', desc: '「{dimensions}」显示评论谈到哪些方面、各占多少比重、各自得分；「{summary}」用一句话概括这条评论。' },
            note: { title: '备注', desc: '给团队写内部备注，只在 WTK 里可见，不会发到平台上。' },
            actions: { title: '转发和回复', desc: '「{forward}」用邮件发给同事处理；「{reply}」根据「{replySetting}」生成 AI 回复草稿，修改后复制到平台上回复。' },
            actionsGoogle: { title: '转发和回复', desc: '「{forward}」用邮件发给同事处理；「{reply}」根据「{replySetting}」生成 AI 回复草稿，可以修改、复制，或直接发到 Google。' },
            actionsReplied: { title: '转发和回复', desc: '「{forward}」用邮件发给同事处理。这条评论已经回复过，所以按钮显示「{replied}」；还没回复的评论点「{reply}」，会根据「{replySetting}」生成 AI 回复草稿，修改后复制到平台上回复。' },
        },
    },
    homeGuide: {
        skip: '跳过',
        prev: '上一步',
        next: '下一步',
        finish: '完成',
        steps: {
            overview: { title: '仪表盘概览', desc: '这里汇总了平台整体表现，包括响应率、24 小时动态和上周亮点与问题，帮你快速了解酒店近期状况。' },
            dateRange: { title: '时间范围', desc: '在这里切换统计的时间区间和评论平台，下方所有图表和数据都会按你选择的范围自动更新。' },
            needsAttention: { title: '需要关注的问题', desc: '按评论数、评分和影响程度列出最值得关注的问题子类，点击任意一行还能查看对应的详细数据。' },
            highlights: { title: '优势与待改进点', desc: '通过"优势/问题"切换，查看上周住客提到最多的优势关键词，以及需要改进的问题关键词。' },
            evidence: { title: '查看原始评论', desc: '点击下方任意分类卡片（如位置、清洁度等），即可弹出该分类相关的原始评论证据，快速定位问题来源。' },
        },
    },
    // 404 页（views/error/404.vue）
    NotFound:{
        desc:"啊哦~ 你所访问的页面不存在",
        backHome:"返回首页",
    },
    menu:{
        // Quality Standards 页：侧栏用短名，页面头部用全称。
        'Quality Standards': '质量标准',
        // 新版 WTK Luxury Standards 的侧栏名（只给 featureGates.js 的 LUXURY_STANDARDS_HOTELS）。页面本身只有英文
        'Luxury Standards': '奢华服务标准',
        // 半年报两个侧栏入口（RouterMenu.vue）。de / it 暂用英文
        'Market Signals': '市场趋势洞察',
        'Half-Year Review': '半年度回顾',
        // 酒店那份半年报改名 Period Review（周期长度会变，名字里不写时长）；F&B 仍用上面那条
        'Period Review': '周期回顾',
        QualityStandards_Title: '宾客反馈与质量标准',
        QualityStandards_EmptyTitle: '该酒店暂无标准数据',
        QualityStandards_EmptyDesc: '当前的 LQA / Forbes / 米其林数据集未覆盖这家酒店。请在酒店切换器里选择已覆盖的酒店查看。',
        'Hotel Overview': '酒店概览',
        'Hotel Dashboard': '酒店概述',
        'Reports': '报告',
        'PortiolioBriefing': '综合报告',
        BrandOverview:'品牌概览',
        BrandOverview2:'组合解析',
        // 品牌模式侧边栏"Hotel Reviews"分组下的品牌列表入口——文案和上面两个 key 都不一样，
        // 是特意起的新 key，避免和 /BrandOverview、/BrandOverview2 这两个不同页面的文案混用。
        BrandOverviewList:'品牌总览',
        'Restaurant Dashboard': '餐厅管理仪表盘',
        'Reviews & Reply': '评论与回复',
        'ReplyLike': '回复模板',
        'Reviews': '评论',
        'Replies': '回复设置',
        'Reply Setting': '回复设置',
        'Competitors' : '竞争分析',
        'Settings' : '系统设置',
        'Restaurant' : '餐厅',
        'Help Center (FAQ)':'帮助中心 (常见问题)',
        'AI Chat':'智能分析',

        'Dashboards': '概览',
        'dashboard': '概览',
        'Restaurant Overview': '餐厅概览',
        'Reviews & Replies': '案例管理',
        'Case Management': '案例管理',
        'Hotel': '酒店',
        // 侧边栏 Hotel/F&B/Brand 三态切换器专用——刻意不复用上面的 'Restaurant' key,
        // 那个 key 还在别处当"餐厅"通用菜单文案用,不能被这里的"F&B"说法带偏。
        'F&B': '餐厅',
        'Brand': '品牌',
        'Hotel Reviews': '酒店评论',
        'Restaurant Reviews': '餐厅评论',
        'Hotel Reply Setting': '酒店评论设置',
        'Hotel Reply Template': '酒店回复模板',
        'Food & Beverage': '餐厅',
        'F&B Reviews': '餐厅评论',
        'F&B Reply Setting': '餐厅评论设置',
        'F&B Reply Template': '餐厅回复模板',
        'Competition': '竞争',
        'Hotel Competitors': '酒店竞争对手',
        'Restaurant Competitors': '餐厅竞争对手',
        'Competitors_OTA_Reports': '市场概览',
        'Competitors_Benchmarks': '竞品基准',
        'Insights':'解析',
        'Brand Overview':'品牌概览',
        'Generals':'综合',
        'Setting':'系统设置',
        'Survey':'调查',
        'Surveys':'调查',
        'During Stay':'入住中',
        'Post Stay':'离店后',
        'Survey Detail':'调查详情',
        'Needs Attention':'待跟进评论',
        'Reply Library':'回复库',
        'Staff Management':'员工管理',
        'Connections':'平台连接',
        // 品牌模式侧栏的 Active Signal Details 入口
        ActiveSignalDetails:'活跃信号详情',
    },
    DateMonth:{
        Jan:'一月',
        Feb:'二月',
        Mar:'三月',
        Apr:'四月',
        May:'五月',
        Jun:'六月',
        Jul:'七月',
        Aug:'八月',
        Sep:'九月',
        Oct:'十月',
        Nov:'十一月',
        Dec:'十二月'
    },
    Filter:'筛选',
    Date:'日期',
    SML_ReviewsShowBox:{
        emptyState:{
            title:'没有符合当前筛选条件的评论',
            description:'当前筛选条件下没有评论结果，请调整或重置筛选条件。',
            resetBtn:'重置筛选',
        },
    },
    inputPlaceholder:"请输入",
    selectPlaceholder:"请选择",
    Frequency:"频率",
    Example:'示例: ',
    Sort:'排序依据',
    Score:'得分',
    WTK_Score:'WQI',
    Time:'时间',
    Email:'电子邮件',
    Proportion:'比例',
    No_of_reviews:'评论数量',
    No_data:'暂无数据',
    NA:'N/A',
    average:'平均值',
    reviewsAvg:'评论均值',
    Diff:'差异',
    Hotel:'酒店',
    Restaurant:'餐厅',
    Reviews:"评论",
    Review:"评论",
    Reply:"回复",
    Edit:"编辑",
    Add:"添加",
    engagements:"互动总数",
    Submit:"提交",
    Title:"标题",
    show_details:'显示详情',
    Loading:'正在加载',
    Load_failed:'加载失败',
    Report_not_ready:'报告尚未生成',
    Report_not_ready_desc:'该周期尚未到生成时间，或数据仍在处理中，请稍后再查看。',
    Retry_after_refreshing:'刷新后重试',
    LoadingData:'正在加载数据',
    LoadingNewData:'加载新数据',
    LoadingInitialData:'加载初始数据',
    Category:'类别',
    copySuccess:'复制成功！',
    Global:'全球',
    Show_All:'全部',
    SubcategoryAttention_title:'区域警告',
    SubcategoryAttention_tooltip:'子类别得分低于8.0，按整体影响排名。评论显示中性 + 负面数量。影响 = (子类别得分 - 整体得分) × 评论权重，衡量每个区域对整体得分的影响程度。',
    SubcategoryAttention_empty:'所有子类别表现良好。',
    echartsNoData1:'当前时间段暂无数据',
    echartsNoData2:'请尝试选择其他时间范围，或稍后再试，当新的数据更新后将自动显示',
    // WTK-578 图表空状态按原因区分（EchartsNoData 的 reason）
    echartsNoData_noScored1:'该时间段内没有带评分的评论',
    echartsNoData_noScored2:'趋势图只显示有评分评论的时间段。可以试试更长的时间范围，比如「本季度以来」。',
    echartsNoData_noCategory1:'该时间段内没有评论提到「{category}」',
    echartsNoData_noCategory2:'可以切回「总分」，或选择更长的时间范围，比如「本季度以来」。',
    CategoryObj:{
        "Location & Neighborhood":"地理位置与周边",
        'Location & Neighbourhood':'地理位置与周边',
        Location:'地理位置与周边',

        "Cleanness":"清洁卫生",
        "Cleanliness":"清洁卫生",

        Room:'客房舒适度',
        "Room Facilities & Comfort":"客房舒适度",
        "Room Comfort":"客房舒适度",
        'Room & Amenities':'客房舒适度',

        'Hotel Atmosphere & Design':'酒店设施与氛围',
        Amenities:'酒店设施与氛围',
        "Hotel Amenities & Atmosphere":"酒店设施与氛围",
        'Hotel Facilities & Amenities':'酒店设施与氛围',

        "Food & Beverage":"餐饮体验",
        'F&B Experience':'餐饮体验',
        "F & B":"餐饮体验",
        "F&B":"餐饮体验",

        Services:'宾客体验与服务',
        Service:'宾客体验与服务',
        "Guest Experience & Service":"宾客体验与服务",

        Value:'性价比',
        "Value for Money":"性价比",
        "Value For Money":"性价比",
        'Brand Consistency & Expression':'品牌',
        Brand:'品牌',
        "Food Quality":"食物质量",
        "Beverage Quality":"饮品质量",
        "Service Quality":"服务质量",
        "Ambience":"环境氛围",
        "Cleanliness":"清洁卫生",
        "Value Perception":"性价比",
    },
    CategoryLabel:[
        {
            name1:"总分",
            name2:"总分",
            icon:'',
            icon1:'',
            value:"total",
            value1:"total",
            value2:"total",
        },
        {
            name1:"位置",
            name2:"地理位置",
            icon2:Group4,
            icon1:icon_Location,
            icon:Group1_1,
            value:"Location",
            value1:"location_neighbourhood",
            value2:"Location & Neighbourhood",
        },
        {
            name1:"卫生",
            name2:"卫生",
            icon2:Group2,
            icon1:icon_Cleanness,
            icon:Group2_1,
            value:"Cleanness",
            value1:"cleanliness",
            value2:"Cleanliness",
        },
        {
            name1:"客房",
            name2:"客房舒适度",
            icon2:Group3,
            icon1:icon_Room,
            icon:Group3_1,
            value:"Room",
            value1:"room_comfort",
            value2:"Room Comfort",
        },
        {
            name1:"酒店设施",
            name2:"酒店设施与氛围",
            icon2:Group1,
            icon1:icon_Amenities,
            icon:Group4_1,
            value:"Amenities",
            value1:"hotel_amenities_atmosphere",
            value2:"Hotel Amenities & Atmosphere",
        },
        {
            name1:"餐饮",
            name2:"餐饮",
            icon2:Group5,
            icon1:icon_FB,
            icon:Group6_1,
            value:"F & B",
            value1:"food_beverage",
            value2:"Food & Beverage",
        },
        {
            name1:"服务",
            name2:"服务体验",
            icon2:Group7,
            icon1:icon_Service,
            icon:Group5_1,
            value:"Service",
            value1:"guest_experience_service",
            value2:"Guest Experience & Service",
        },
        {
            name1:"性价比",
            name2:"性价比",
            icon2:Group6,
            icon1:icon_Value,
            icon:Group7_1,
            value:"Value",
            value1:"value_for_money",
            value2:"Value for Money",
        },
        {
            name1:"食物质量",
            name2:"食物质量",
            icon2:Food_Quality,
            icon1:Food_Quality,
            icon:Food_Quality,
            value:"Food Quality",
            value1:"food_quality",
            value2:"Food Quality",
        },
        {
            name1:"饮品质量",
            name2:"饮品质量",
            icon2:Beverage_Quality,
            icon1:Beverage_Quality,
            icon:Beverage_Quality,
            value:"Beverage Quality",
            value1:"beverage_quality",
            value2:"Beverage Quality",
        },
        {
            name1:"服务质量",
            name2:"服务质量",
            icon2:Service_Quality,
            icon1:Service_Quality,
            icon:Service_Quality,
            value:"Service Quality",
            value1:"service_quality",
            value2:"Service Quality",
        },
        {
            name1:"环境氛围",
            name2:"环境氛围",
            icon2:Ambience,
            icon1:Ambience,
            icon:Ambience,
            value:"Ambience",
            value1:"ambience",
            value2:"Ambience",
        },
        {
            name1:"性价比",
            name2:"性价比",
            icon2:Value_For_Money,
            icon1:Value_For_Money,
            icon:Value_For_Money,
            value:"Value For Money",
            value1:"value_for_money",
            value2:"Value For Money",
        },
        {
            name1:"清洁卫生",
            name2:"清洁卫生",
            icon2:Group2,
            icon1:icon_Cleanness,
            icon:Group2_1,
            value:"Cleanliness",
            value1:"cleanliness",
            value2:"Cleanliness",
        },
    ],
    CategoryLabel1:[
        {
            name1:"总分",
            name2:"总分",
            icon:'',
            icon1:'',
            value:"total",
            value1:"total",
        },
        {
            name1:"位置",
            name2:"地理位置",
            icon2:Group4,
            icon1:icon_Location,
            icon:Group1_1,
            value:"Location",
            value1:"location_neighbourhood",
        },
        {
            name1:"卫生",
            name2:"卫生",
            icon2:Group2,
            icon1:icon_Cleanness,
            icon:Group2_1,
            value:"Cleanness",
            value1:"cleanliness",
        },
        {
            name1:"客房",
            name2:"客房舒适度",
            icon2:Group3,
            icon1:icon_Room,
            icon:Group3_1,
            value:"Room",
            value1:"room_comfort",
        },
        {
            name1:"酒店设施",
            name2:"酒店设施与氛围",
            icon2:Group1,
            icon1:icon_Amenities,
            icon:Group4_1,
            value:"Amenities",
            value1:"hotel_amenities_atmosphere",
        },
        {
            name1:"餐饮",
            name2:"餐饮",
            icon2:Group5,
            icon1:icon_FB,
            icon:Group6_1,
            value:"F & B",
            value1:"food_beverage",
        },
        {
            name1:"服务",
            name2:"服务体验",
            icon2:Group7,
            icon1:icon_Service,
            icon:Group5_1,
            value:"Service",
            value1:"guest_experience_service",
        },
        {
            name1:"性价比",
            name2:"性价比",
            icon2:Group6,
            icon1:icon_Value,
            icon:Group7_1,
            value:"Value",
            value1:"value_for_money",
        },
        {
            name1:"品牌",
            name2:"品牌",
            icon2:icon_Brand,
            icon1:icon_Brand,
            icon:Group8_1,
            value:"Brand",
            value1:"brand_consistency_expression",
        },
    ],
    RestaurantObj:{
        'Food Quality':'食物质量',
        'Taste & Flavor':'味道与风味',
        'Freshness':'食材新鲜度',
        'Temperature':'上菜温度',
        'Portion Size':'份量大小',
        'Food Presentation':'摆盘呈现',
        'Menu Variety':'菜单菜品多样性',
        'Innovation & Uniqueness':'创意与特色',
        'General': '总体评价',
        "Beverage Quality":"饮品质量",
        "Taste & Preparation":"口感与制作",
        "Mixology Skill":"调酒技巧",
        "Alcohol Selection":"酒单丰富度",
        "Non-Alcohol Selection":"非酒精选项",
        "Drink Presentation":"饮品呈现",
        "Drink Menu & Variety":"饮品菜单多样性",
        "Drink Innovation & Uniqueness":"饮品创意与特色",
        "View & Scenery":"景观与景色",
        'Service Quality':'服务质量',
        'Professionalism':'专业素养',
        'Efficiency':'服务效率',
        'Accuracy':'准确性',
        'Personalization':'个性化服务',
        'Problem Resolution':'问题处理',
        'Staffing & Team Coordination':'人手与团队协作',
        'Bartender':'调酒师服务',
        'Reservation & Waiting':'预订与等位',
        'Access, Arrival & Seating':'入店、到店与入座',
        'Guest Safety & Fair Treatment':'宾客安全与公平对待',

        "Ambience":'环境氛围',
        "Decor & Design":'装潢设计',
        "Lighting":'光线',
        "Music & Noise":'音乐与噪音',
        "Air Quality":'空气质量',
        "Temperature & Ventilation":'室温与通风',
        "Privacy":'私密性',
        "Seating Comfort":'座位舒适度',
        "Atmosphere":'氛围感',
        "Facilities & Maintenance":'设施与维护',

        "Cleanliness":'清洁卫生',
        "Tableware Hygiene":'餐具卫生',
        "Dining Area":'餐厅环境卫生',
        "Restroom":'洗手间卫生与气味',
        "Staff Appearance":'员工仪容整洁度',
        "Kitchen & Food Handling":'备餐区',
        "Pest Control":'虫害防治',

        "Value Perception":'性价比',
        "Overall Worthiness":'整体价值感',
        "Quality & Service vs Price":'质量与服务匹配度',
        "Portion vs Price":'份量与价格匹配度',
        "Overall Satisfaction / Disappointment":'总体感受',
        "Perceived Value vs Expectation":'总体感受',
        "Price Transparency & Charging":'价格透明度与收费',
    },
    OTAs:{
        HOLIDAYCHECK:'HolidayCheck',
        HRS:'HRS',
        LASTMINUTE:'lastminute.com',
        TRIVAGO:'trivago',
        PRICELINE:'Priceline',
        HOTELSCOM:'Hotels.com',
        HOTELESCOM:'Hoteles.com',
        RAKUTEN:'乐天旅游',
        TRAVELOKA:'Traveloka',
        HOSTELWORLD:'Hostelworld',
        TRAVELOCITY:'Travelocity',
        ORBITZ:'Orbitz',
        LUXURYESCAPES:'Luxury Escapes',
        INTERNAL:'Internal',
        Internal:'Internal',
        MAKEMYTRIP:'MakeMyTrip',
        HOTELDE:'hotel.de',
        HolidayCheck:'HolidayCheck',
        Lastminute:'lastminute.com',
        Trivago:'trivago',
        Priceline:'Priceline',
        Hotelscom:'Hotels.com',
        Rakuten:'乐天旅游',
        Traveloka:'Traveloka',
        Hostelworld:'Hostelworld',
        Travelocity:'Travelocity',
        Orbitz:'Orbitz',
        LuxuryEscapes:'Luxury Escapes',
        MakeMyTrip:'MakeMyTrip',
        HotelDe:'hotel.de',
        BOOKING:'缤客网',
        TRIP:'携程',
        EXPEDIA:'亿客行',
        GOOGLE:'谷歌',
        TRIPADVISOR:'猫途鹰',
        OPENTABLE:'OpenTable',
        YELP:'Yelp',
        WONGNAI:'Wongnai',
        Booking:'缤客网',
        AGODA:'安可达',
        agoda:'安可达',
        Trip:'携程',
        Google:'谷歌',
        Tripadvisor:'猫途鹰',
        Expedia:'亿客行',
        Yelp:'Yelp',
        Wongnai:'Wongnai',
        'Google Map':'谷歌',
        'Open Table':'Open Table',
        'OpenTable':'Open Table',
    },
    baseLanguages:[
        { label: "英语", value: "English" },
        { label: "德语", value: "German" },
        { label: "法语", value: "French" },
        { label: "意大利语", value: "Italian" },
        { label: "西班牙语", value: "Spanish" },
        { label: "葡萄牙语", value: "Portuguese" },
        { label: "瑞典语", value: "Swedish" },
        { label: "中文", value: "Chinese" },
        { label: "日语", value: "Japanese" },
        { label: "韩语", value: "Korean" },
        { label: "阿拉伯语", value: "Arabic" },
        { label: "俄语", value: "Russian" },
        { label: "土耳其语", value: "Turkish" },
        { label: "泰语", value: "Thai" },
        { label: "越南语", value: "Vietnamese" },
        { label: "印度尼西亚语 / Bahasa", value: "Indonesian / Bahasa" },
        { label: "荷兰的", value: "Dutch" },
        { label: "波兰语", value: "Polish" },
        { label: "希腊语", value: "Greek" },
        { label: "希伯来语", value: "Hebrew" },
    ],
    TravellerType:{
        "Couple":"情侣/夫妻",
        "Solo":"独行旅客",
        "Group":"团体",
        "Family":"家庭",
        "Business":"商务旅客",
        "unknown":"未知",
        "Unknown":"未知",
        "UNKNOWN":"未知",
        "FAMILY":"家庭",
        "COUPLE":"情侣/夫妻",
        "SOLO":"独行旅客",
        "GROUP":"团体",
        "BUSINESS":"商务旅客",
    },
    punctuationMarks:{
        quotationMarks1:' “ ',
        quotationMarks2:' ” ',
    },
    subCategories:{
        accessibility:"交通便捷度",
        neighbourhood_facilities:"周边设施丰富度",
        safety:"安全感",
        views:"景观视野",

        room_hygiene:"客房卫生",
        bathroom_hygiene:"浴室卫生",
        public_area_hygiene:"公共区域整洁度",
        odour:"气味",
        restaurant_cleanness:"餐饮区卫生",

        bed_quality:"床品舒适度",
        sound_insulation:"隔音",
        air_conditioning_heating:"空调/暖气",
        room_size:"房间尺寸",
        lighting:"光线",
        shower_water_pressure:"水压",
        room_design:"设计感与布局",
        room_maintenance:"客房维护",
        in_room_amenities:"客房用品",

        wifi_internet:"网络",
        // toKey("Wi-Fi & Internet") 得到的是 wi_fi_internet(连字符也会变成下划线),
        // 和上面那个历史 key 对不上,两个都留着。
        wi_fi_internet:"网络",
        gym:"健身房",
        swimming_pool:"泳池",
        spa:"水疗中心",
        elevator:"电梯",
        business_centre:"商务中心",
        meeting_rooms:"会议厅",
        car_parking:"停车场",
        executive_lounge:"行政酒廊",
        hotel_atmosphere_design:"整体设计与品牌氛围",
        beach_outdoor_areas:"海滩与户外区域",
        kids_family_facilities:"儿童与家庭设施",

        breakfast:"早餐",
        restaurant:"餐厅体验",
        bar:"酒吧",
        coffee_beverages:"咖啡与饮品",
        in_room_dining:"客房送餐",
        service_and_efficiency:"服务态度与效率",

        booking:"预订体验",
        membership_benefits:"会员待遇",
        // special_request_handling:"特殊需求处理",
        personalised_request_handling:"个性化需求处理",
        personalised_service:"个性化服务",
        // front_desk_concierge:"前台与礼宾服务",
        concierge:"礼宾服务",
        check_in:"入住办理",
        check_out:"退房办理",
        in_room_request:"房内请求",
        housekeeping:"客房打扫",
        // cleaning_tidying:"清洁与整理",
        flexibility_guest_needs:"客人需求的灵活性",
        flexibility_of_guest_needs:"客人需求的灵活性",
        butler_service:"管家服务",
        hotel_transportation:"酒店交通",
        complaints_feedback:"投诉与反馈处理",
        guest_treatment_fairness:"宾客待遇公平性",
        lounge_service:"行政酒廊服务",
        spa_gym_pool_service:"SPA、健身房与泳池服务",
        billing:"账单问题",
        points_arrival_speed:"积分到账速度",
        customer_service_response:"响应速度",
        communication_language:"沟通能力",
        security_safety:"安保与安全",

        price_fairness:"价格合理度",
        experience_matching_price:"体验与价格匹配度",
        hidden_fees:"隐性费用",
        promotions_membership_benefits:"会员优惠",
        overall_satisfaction:"总体感受",
        // 接口在 Value for Money 下实际返回的是这个全称 key,SUBCATEGORY_MAP 里
        // 没有对应项,所以只能在这里单独补(缺了它界面会直接显示 i18n 路径原文)。
        overall_satisfactions_or_disappointments:"总体感受",
        local_cultural_expression:'当地文化表达',
        general:'总体',
    },
    login:{
        Open_in_app_tip:'移动端访问该页面可能会影响体验，是否打开 App？',
        Open_in_app_title:'是否继续 Where to Know？',
        Open_in_app_subtitle:'该页面建议在 Where to Know App 中打开',
        Open_in_app_button:'打开App',
        Reset_your_password:'重置您的密码',
        Email_address:'电子邮件地址',
        Log_in:'登录以开始使用',
        Reset_password:'重置密码',
        Log_in_to_start_your_session:'登录您的账户',
        placeholder1:'邮箱地址',
        placeholder2:'密码',
        Remember_me:'保持登录状态',
        module_hotel:'酒店',
        module_restaurant:'餐厅',
        module_brand:'品牌',
        Forget_your_password:'忘记密码？',
        Back_to_login:'返回登录',
        Send_reset_link:'发送重置链接',
        Password_requirements:'密码要求：',
        Password_requirements1:'必须包含数字、大写字母，',
        Password_requirements2:'以及一个小写字母。',
        Verify_your_email:'验证您的邮箱',
        Verify_your_email1:"我们已经通过电子邮件向您发送了一个六位数的注册码。",
        Verify_your_email2:"请在下面输入代码。",
        Email_me_another_verification_code:"给我发另一个验证码",
        Repeat_new_password:"重复新密码",
        Are_you_sure_you_want_to_logout:'您确定要注销吗？',
        Confir_Logout:'确认注销',
        Confirm:'确认',
        Cancel:'取消',
        Current_password_is_incorrect:'当前密码错误',
    },
    Region:[
        {
            label:'全球',
            value:'GLOBAL',
            icon1:global,
        },
        {
            label:'大中华地区',
            value:'GREATER_CHINA',
            icon1:CHINA,
        },
        {
            label:'亚太区（中国除外）',
            value:'APAC_EX_CHINA',
            icon1:APAC,
        },
        {
            label:'中东',
            value:'MIDDLE_EAST',
            icon1:MIDDLE_EAST,
        },
        {
            label:'欧洲',
            value:'EUROPE',
            icon1:EMEA,
        },
        {
            label:'非洲',
            value:'AFRICA',
            icon1:AFRICA,
        },
        {
            label:'北美洲',
            value:'NORTH_AMERICA',
            icon1:N_A,
        },
        {
            label:'南美洲',
            value:'SOUTH_AMERICA',
            icon1:SOUTH_AMERICA,
        },
    ],

    geo:{
        global:'全球',
        americas:'美洲',
        north_america:'北美洲',
        latin_america:'拉丁美洲',
        emea:'欧洲、中东及非洲',
        europe:'欧洲',
        middle_east:'中东',
        africa:'非洲',
        apac:'亚太区',
        southeast_asia:'东南亚',
        japan:'日本',
        korea:'韩国',
        australia_pacific:'澳洲及太平洋',
        india:'印度及南亚',
        greater_china:'大中华地区',
        mainland_china:'中国大陆',
        hong_kong:'香港',
        taiwan:'台湾',
        macau:'澳门',
        countries:{
            'United States':'美国',
            'USA':'美国',
            'Canada':'加拿大',
            'Mexico':'墨西哥',
            'Brazil':'巴西',
            'Argentina':'阿根廷',
            'Chile':'智利',
            'Colombia':'哥伦比亚',
            'Peru':'秘鲁',
            'Costa Rica':'哥斯达黎加',
            'Panama':'巴拿马',
            'Dominican Republic':'多米尼加共和国',
            'Puerto Rico':'波多黎各',
            'Jamaica':'牙买加',
            'Bahamas':'巴哈马',
            'Bermuda':'百慕大',
            'Guatemala':'危地马拉',
            'Honduras':'洪都拉斯',
            'El Salvador':'萨尔瓦多',
            'Nicaragua':'尼加拉瓜',
            'Belize':'伯利兹',
            'Cuba':'古巴',
            'Haiti':'海地',
            'Ecuador':'厄瓜多尔',
            'Venezuela':'委内瑞拉',
            'Bolivia':'玻利维亚',
            'Paraguay':'巴拉圭',
            'Uruguay':'乌拉圭',
            'Guyana':'圭亚那',
            'Suriname':'苏里南',
            'Aruba':'阿鲁巴',
            'Curacao':'库拉索',
            'Curaçao':'库拉索',
            'Trinidad and Tobago':'特立尼达和多巴哥',
            'Barbados':'巴巴多斯',
            'Cayman Islands':'开曼群岛',
            'Saint Lucia':'圣卢西亚',
            'Antigua and Barbuda':'安提瓜和巴布达',
            'Grenada':'格林纳达',
            'Dominica':'多米尼克',
            'Saint Kitts and Nevis':'圣基茨和尼维斯',
            'Saint Vincent and the Grenadines':'圣文森特和格林纳丁斯',
            'Turks and Caicos Islands':'特克斯和凯科斯群岛',
            'British Virgin Islands':'英属维尔京群岛',
            'U.S. Virgin Islands':'美属维尔京群岛',
            'Guadeloupe':'瓜德罗普',
            'Martinique':'马提尼克',
            'Greenland':'格陵兰',
            'United Kingdom':'英国',
            'UK':'英国',
            'France':'法国',
            'Germany':'德国',
            'Italy':'意大利',
            'Spain':'西班牙',
            'Netherlands':'荷兰',
            'Switzerland':'瑞士',
            'Austria':'奥地利',
            'Belgium':'比利时',
            'Portugal':'葡萄牙',
            'Sweden':'瑞典',
            'Norway':'挪威',
            'Denmark':'丹麦',
            'Finland':'芬兰',
            'Ireland':'爱尔兰',
            'Greece':'希腊',
            'Czech Republic':'捷克',
            'Poland':'波兰',
            'Hungary':'匈牙利',
            'Croatia':'克罗地亚',
            'Romania':'罗马尼亚',
            'Turkey':'土耳其',
            'Russia':'俄罗斯',
            'Bulgaria':'保加利亚',
            'Slovakia':'斯洛伐克',
            'Slovenia':'斯洛文尼亚',
            'Serbia':'塞尔维亚',
            'Bosnia and Herzegovina':'波斯尼亚和黑塞哥维那',
            'Montenegro':'黑山',
            'North Macedonia':'北马其顿',
            'Albania':'阿尔巴尼亚',
            'Kosovo':'科索沃',
            'Moldova':'摩尔多瓦',
            'Ukraine':'乌克兰',
            'Belarus':'白俄罗斯',
            'Lithuania':'立陶宛',
            'Latvia':'拉脱维亚',
            'Estonia':'爱沙尼亚',
            'Liechtenstein':'列支敦士登',
            'Andorra':'安道尔',
            'San Marino':'圣马力诺',
            'Czechia':'捷克',
            'Iran':'伊朗',
            'Iraq':'伊拉克',
            'Syria':'叙利亚',
            'Yemen':'也门',
            'Palestine':'巴勒斯坦',
            'Afghanistan':'阿富汗',
            'Algeria':'阿尔及利亚',
            'Tunisia':'突尼斯',
            'Libya':'利比亚',
            'Sudan':'苏丹',
            'Senegal':'塞内加尔',
            'Ivory Coast':'科特迪瓦',
            "Côte d'Ivoire":'科特迪瓦',
            'Cameroon':'喀麦隆',
            'Uganda':'乌干达',
            'Zambia':'赞比亚',
            'Zimbabwe':'津巴布韦',
            'Botswana':'博茨瓦纳',
            'Namibia':'纳米比亚',
            'Mozambique':'莫桑比克',
            'Madagascar':'马达加斯加',
            'Angola':'安哥拉',
            'Brunei':'文莱',
            'Bhutan':'不丹',
            'Timor-Leste':'东帝汶',
            'North Korea':'朝鲜',
            'Republic of Korea':'韩国',
            'New Caledonia':'新喀里多尼亚',
            'Samoa':'萨摩亚',
            'Tonga':'汤加',
            'Vanuatu':'瓦努阿图',
            'Palau':'帕劳',
            'Luxembourg':'卢森堡',
            'Monaco':'摩纳哥',
            'Malta':'马耳他',
            'Cyprus':'塞浦路斯',
            'Iceland':'冰岛',
            'Georgia':'格鲁吉亚',
            'Azerbaijan':'阿塞拜疆',
            'Armenia':'亚美尼亚',
            'Kazakhstan':'哈萨克斯坦',
            'Uzbekistan':'乌兹别克斯坦',
            'Kyrgyzstan':'吉尔吉斯斯坦',
            'Tajikistan':'塔吉克斯坦',
            'Turkmenistan':'土库曼斯坦',
            'UAE':'阿联酋',
            'United Arab Emirates':'阿联酋',
            'Saudi Arabia':'沙特阿拉伯',
            'Qatar':'卡塔尔',
            'Bahrain':'巴林',
            'Kuwait':'科威特',
            'Oman':'阿曼',
            'Jordan':'约旦',
            'Lebanon':'黎巴嫩',
            'Israel':'以色列',
            'Egypt':'埃及',
            'South Africa':'南非',
            'Morocco':'摩洛哥',
            'Kenya':'肯尼亚',
            'Tanzania':'坦桑尼亚',
            'Nigeria':'尼日利亚',
            'Ghana':'加纳',
            'Ethiopia':'埃塞俄比亚',
            'Rwanda':'卢旺达',
            'Mauritius':'毛里求斯',
            'Seychelles':'塞舌尔',
            'Thailand':'泰国',
            'Singapore':'新加坡',
            'Vietnam':'越南',
            'Indonesia':'印度尼西亚',
            'Malaysia':'马来西亚',
            'Philippines':'菲律宾',
            'Myanmar':'缅甸',
            'Cambodia':'柬埔寨',
            'Laos':'老挝',
            'Japan':'日本',
            'South Korea':'韩国',
            'Korea':'韩国',
            'Australia':'澳大利亚',
            'New Zealand':'新西兰',
            'Fiji':'斐济',
            'Papua New Guinea':'巴布亚新几内亚',
            'Guam':'关岛',
            'French Polynesia':'法属波利尼西亚',
            'Maldives':'马尔代夫',
            'India':'印度',
            'Sri Lanka':'斯里兰卡',
            'Nepal':'尼泊尔',
            'Bangladesh':'孟加拉国',
            'Pakistan':'巴基斯坦',
            'China':'中国',
            'Hong Kong':'中国香港',
            'Taiwan':'中国台湾',
            'Taiwan (China)':'中国台湾',
            'Macau':'中国澳门',
            'Mongolia':'蒙古',
        },
        cities:{
            'Bangkok':'曼谷',
            'Koh Samui':'苏梅岛',
            'Phang Nga':'攀牙',
            'Chiang Mai':'清迈',
            'Hua Hin':'华欣',
            'Khao Yai':'考艾',
            'Pattaya':'芭提雅',
            'Phuket':'普吉岛',
            'Ko Chang':'象岛',
        },
    },

    selectHotel:{
        Select_Your_Hotel:"选择您的酒店",
        Select_Your_Restaurant:"选择您的餐厅",
        Select_Your_Brand:"选择您的品牌",
        Choose_any_of_the_following_hotels:"选择一家酒店以继续",
        Choose_a_restaurant_to_continue:"选择一家餐厅以继续",
        Choose_a_brand_to_continue:"选择一个品牌以继续",
        Loading_hotels:"正在加载酒店",
        Confirm_Continue:"确认并继续",
        Need_assistance_Contact_support:"需要帮助？联系支持",
    },
    current:{
        Date:"今日日期:",
        Updated:"本地时间:",
    },
    chat:{
        title:'智能分析',
        welcomeTitle:'问我关于你评论数据的任何问题',
        welcomeSub:'数据分析助手 · 测试版(Beta)',
        betaNotice:'AI 生成的回答仅供参考，请结合后台数据进行核实。',
        betaNoticeL1:'AI 助手目前处于测试阶段，回答可能偶有不准确。',
        betaNoticeL2:'重要洞察请以后台数据为准进行核实。',
        betaBadge:'AI 助手（Beta）',
        quotaWarnDay:'本酒店今日的 AI 助手用量已使用约 {pct}%,明天自动重置。',
        quotaWarnMonth:'本酒店本月的 AI 助手用量已使用约 {pct}%,下月 1 号自动重置。',
        thinking:'思考过程',
        steps:'执行步骤({n})',
        analyzing:'正在分析评论…',
        newChat:'新对话',
        delete:'删除',
        deleteConfirm:'确定要删除这条会话吗？此操作不可撤销。',
        deleted:'已删除会话',
        feedbackUp:'有帮助',
        feedbackDown:'没帮助',
        copy:'复制',
        copied:'已复制',
        copyFailed:'复制失败',
        unknownUser:'未知用户',
        byAuthor:'由 {name} 提问',
        groupToday:'今天',
        groupYesterday:'昨天',
        groupLast7:'7 天内',
        groupLast30:'30 天内',
        groupOlder:'更早',
        insightsTitle:'本周有 {n} 条值得关注',
        insightsBadge:'注意事项摘要',
        insightsUrgent:'其中 {n} 条优先级高',
        insightsCta:'我应该优先关注什么？',
        periodSwitch:'换个时间段：',
        period7d:'最近 7 天',
        periodMonth:'本月',
        periodQuarter:'本季度',
        periodYtd:'年初至今',
        samePeriod:'同样的问题，看{period}',
        insightsView:'问问 AI',
        insightsAsk:'最近系统标记了哪些异常？帮我分析下原因和应对建议。',
        evidence:'来源',
        hideEvidence:'隐藏',
        evidenceHint:'点击任意回答下方的「来源」标记，查看它的依据。',
        viewReportPdf:'打开报告 PDF',
        reportPdfError:'无法打开报告 PDF，请重试。',
        evReviews:'评论',
        evReports:'报告',
        evWeb:'网络',
        viewOnSource:'前往原帖',
        viewSource:'查看来源',
        expandReview:'展开',
        collapseReview:'收起',
        placeholder:'输入问题，回车发送（Shift+Enter 换行）',
        suggestions:[
            '最近有什么需要注意的异常？',
            '为什么这个月的评价变差了？',
            '我们这个月的目标达标了吗？',
            '和竞品比我们表现怎么样？',
            '这个月哪些员工被客人点名表扬？都夸了什么？',
            '这个城市最近有什么活动或新闻会影响入住？',
        ],
        tools:{
            query_metrics:'查询指标',
            list_reviews:'拉取评论',
            render_chart:'生成图表',
            load_skill:'加载分析方法',
        },
    },
    DateTimePickerHome:{
        label1:'上周',
        label2:'上月',
        label3:'近三月',
        label4:'今年以来',
        Last_7_days:'最近7天',
        Last_Month:'上月',
        Current_Month:'本月以来',
        Current_Quarter:'本季度以来',
        Current_Year:'本年度以来',
        Custom:'自定义',
        allFrequencyOpts:[
            { value: "DAY", displayLabel: "天" },
            { value: "WEEK", displayLabel: "周" },
            { value: "MONTH", displayLabel: "月" },
        ]
    },
    HotelIndex:{
        title:'酒店仪表盘',
        FilterSheet:{
            OtaPlatform:'OTA 平台',
            DateRange:'时间段',
            DateFrequency:'日期 & 频率',
            DateToolbar:'日期 & 工具栏',
            Apply:'应用',
            More:'更多',
        },
        PackageBanner:{
            regionLabel:'订阅提示',
            viewPlans:'查看方案',
            contactSales:'联系销售',
            trialEnded:'您的免费试用已于 {date} 结束',
            trialEndsOn:'您的免费试用将于 {date} 结束',
            daysRemaining:'剩余 {days} 天',
            readOnlyPurgeNoDays:'数据清理前为只读访问',
        },
        Platform_Overview:{
            title:'1. 平台概览',
            tooltip:'本部分将每周更新',
            tooltip1:'回复率和平均回复时间为示例数据。启用集成后，系统将显示您酒店的真实数据。',
            text2:"回复率:",
            Reviews:"条评论",
            Reviews1:"评论数:",
            ReviewCount:"条评论",
            text3:"平均回复时间:",
            text4:"天",
            notAvailable:"暂无数据",
            unknown:"未知",
            noResponsesYet:"暂无回复",
            lessThanOneDay:"不到 1 天",
            text5:"客人数:",
            text6:"聘用总人数",
            title1:"早间简报",
            text7:'数据加载失败。请稍后尝试重新加载',
            otherPlatforms:'其他平台',
            moveToExpanded:'移至展开区',
            replaceWith:'替换为',
            moreCount:'还有 {count} 个',
            showAll:'显示全部',
            compactView:'紧凑视图',
            manageSources:'管理来源',
            searchSourcesPlaceholder:'搜索来源...',
            featuredSection:'精选（{count}）',
            otherSourcesSection:'其他来源（{count}）',
            moveToFeatured:'移至精选',
            cancel:'取消',
            save:'保存',
            noSearchResults:'没有匹配 "{query}" 的来源',
            ReviewBySources:{
                'Direct booking':'直接预订',
                DirectBookingSurvey:'直接预订（入住后的问卷调查）',
                DirectbookingText:'当前为示例数据。启用集成后，系统将显示您酒店的真实数据。',
                'Information Platforms':'信息平台',
                OTAs:'OTA',
                'Social Media':'社交媒体',
                Directbooking:'直接预订',
                InformationPlatforms:'信息平台',
                SocialMedia:'社交媒体',
            },
            ScoreImprovement:{
                current:'当前',
                target:'目标',
                title:'评分提升模拟器',
                subtitle:'拖动滑块设定目标分数',
                reviewsNeeded:'条满分评价达到',
                projectionDisclaimer:'该预测基于历史评价趋势计算，实际结果可能会有所不同，仅供参考。',
                maxScoreReached:'已达到最高分',
                alreadyAbove:'已达到或超过目标',
                noData:'暂无评分数据',
                predicted:'预估',
                assuming:'假设新评价得分为',
                targetLabel:'目标分数',
                analyzing:'分析中',
                estimatedAt:'预计需要',
                month:'个月',
                months:'个月',
                estimatedTooltip:'基于过去3个月的平均数据；提升评价数量或好评率可加快进度。',
                // ── 稳态模型（近期均分）──
                ceilingLabel:'近期均分',
                ceilingTooltip:'平台分是滑动平均，所以近期新评的均分就是分数的稳态，也是判断评分健康或承压的依据。按当前评论质量，分数最终会停在这里；要越过这条线，靠的是提高新评价的质量，而不是数量。',
                beyondCeilingHint:'目标已超过可达上限',
                week:'周',
                weeks:'周',
                year:'年',
                moreThanDuration:'超过 {duration}',
                // ── 四场景模型：健康徽章 / 理论门槛 / 现实时间 ──
                badgeHealthy:'健康',
                badgeAtRisk:'承压',
                badgeUnknown:'数据不足',
                maintainHealthy:'{score} 目前可以稳定维持',
                maintainAtRisk:'{score} 可能会跌至 {ceiling}',
                maintainAtRiskNoCeiling:'{score} 可能难以维持',
                maintainUnknown:'暂时无法评估评分稳定性',
                stabilityLabel:'评分稳定性',
                cannotAssessYet:'暂时无法评估',
                barToTarget:'升至 {target}：约 {count} 条满分评价',
                barNearMax:'已接近满分',
                barUnavailable:'暂无法估算条数',
                timeExpected:'约 {duration}',
                timeMoreThan:'超过 {duration}',
                timeNoData:'暂无法估算时间',
                timeUnreachableAtAverage:'按当前均分暂时无法达到',
                requiredAvgNote:'新评价均分需高于 {required}',
            },
        },
        Performance_Analytics:{
            title:"2. 绩效分析",
            tooltip1:'本部分将每日更新',
            title1:"整体表现",
            text1:'自定义KPI',
            label1:"酒店亮点Top5",
            label2:"待提升项Top5",
            label3:"客源地",
            label4:"旅客类型",
            card1:"客房舒适度",
            card2:"卫生",
            tooltip2:'请选择其他时间范围或频率',
            tooltip3:'没有可用的改进领域数据',
            categoryGoalsTitle:"类别目标与绩效",
            categoryGapTitle:"类别差距表",
            text2_1:'目标分数',
            text2:'当前分数',
            Score_details:"分数详情",
            Comparison_options:"比较选项：",
            YoY:"同比去年",
            MoM:"环比上月",
            WoW:"环比上周",
            QoQ:"环比上季度",
            'current_period':'本期',
            'previous_period':'上期',
            'the_same_period_last_year':'去年同期',
            cirpieTooltip:'自定义更多指标（如高尔夫、网球场、婚礼或会议等）以追踪酒店特色表现',
            Specific_classification:"具体分类",
            No_of_reviews:"评论数",
            impact:"影响值",
            No_of_reviews_tooltip:"评论不足会影响系统的评级",
            Insufficient_reviews:"评论不足",
            No_reviews:"暂无评论",
            WTK_score_8:"WQI ≥ 8",
            WTK_score_6:"5 ≤ WQI < 8",
            WTK_score_4:"WQI < 5",
            eye_tooltip:{
                Positive:'积极',
                Neutral:'中性',
                Negative:'消极',
                PositiveQTY:'积极',
                NeutralQTY:'中性',
                NegativeQTY:'消极',
                quantity:'数量',
                Reviews_ratio:'比例',
                ReviewsBySubcategory:'按子类别查看',
                sort:'排序依据',
                score:'分数',
                review:'评论数',
            },
            country_tooltip:'请注意，并非所有数据源都提供住客来源信息，因此此处数据可能存在局限性。',
        },
        Current_Situation:{
            title:"本期概览",
            Select_report_type:'选择报告类型',
            Low_Data:'置信度低',
            Low_Data_Tooltip:'样本量较小，洞察仅供参考，可能无法全面反映住客评价趋势。',
            Medium_Data:'置信度中等',
            Medium_Data_Tooltip:'样本量适中，结果呈现初步趋势，建议结合实际情况综合判断。',
            High_Data:'置信度高',
            High_Data_Tooltip:'样本量充足，结果具有较高的统计可靠性，能有效代表住客整体评价。',
            Total_reviews:'评论总数',
            Strengths : "积极: WQI>8",
            Areas_for_improvement : "消极: WQI<7",
            Top_5_Positive:'积极前5',
            Top_5_Negative:'负面前5',
            Week:'周',
            Month:'月份',
            HalfMonth:'半月',
            Quarter:'季度',
            HalfYear:'半年',
            Year:'本年度',
            Last_period:'上个周期',
            Next_period:'下个周期',
            Comment_Ratio:"评论率",
            Highlight:"核心亮点",
            Issue:"核心问题",
            Trend_overview:"趋势概述",
            Total_Score_Overview:"总分概览",
            AI_Score_Tooltip:"基于 Where to Know AI 对所有评论的语义分析，并非直接摘取 OTA 平台评分。",
            Historical_data:"历史数据",
            Current_month_data:"当月数据",
            Top_Lists:"排行榜",
            frequency:"频率",
            Category_Summary:"类别概要",
            Category_Insights:"类别分析",
            category_tab_short:{
                Location:"位置",
                Cleanness:"清洁",
                Room:"客房",
                Amenities:"酒店设施",
                F_and_B:"餐饮",
                Service:"服务",
                Value:"性价比",
                Food_Quality:"食品",
                Beverage_Quality:"饮品",
                Service_Quality:"服务",
                Ambience:"环境",
                Cleanliness:"清洁",
                Value_For_Money:"性价比",
            },
            Expand_All:"展开全部",
            Collapse_All:"收起全部",
            Positive_insight:"正面洞察",
            Negative_insight:"负面洞察",
            Positive_insights:"正面洞察",
            Negative_insights:"负面洞察",
            Recommended_Action:"建议行动",
            Tips_for:"建议·",
            noIssuesReported:"未发现问题",
            provenance_view_one:'基于{n}条评论',
            provenance_view_other:'基于{n}条评论',
            provenance_title:'评论依据',
            provenance_supporting:'相关评论',
            // 类别行显示的是该类别的评论总数，抽屉里只列支撑这一条洞察的那几条 ——
            // 两个数字不一样是对的，但不说明白就像是哪边算错了。
            provenance_subset: '{subject} 共 {total} 条评论，其中 {shown} 条支撑这一条洞察',
            provenance_partial:'显示 {shown} / {total} 条：部分评论已不可访问。',
            provenance_forbidden:'你没有权限查看这些评论。',
            provenance_none:'这些评论都已不可访问。',
            provenance_failed:'评论加载失败，请稍后重试。',
            Management_Focus:"管理重点",
            From_Insights_to_Action:'从洞察到行动',
            From_Insights_to_Action1:'这一时期的管理重点',
            Solution :"管理行动",
            Solution_Sub :"下一周期的运营重点",
            Overall_Solution :"整体解决方案",
            Maintain :"维持",
            Resolve :"解决",
            Category_Solution :"类别解决方案",
            Category_Solution_Text :"本期数据不足。保持当前监测状态",
            insufficient_data:"数据不足",
            Next_refresh:'下次更新',
            Medium_3_5_mentions:'中等数据量（3-5次提及），分析可能有限',
            Low_3_mentions:"数据量低（<3次提及），分析有限",
            limitedData:'数据有限，可能不够有代表性',
            period_Insufficient:'本期数据不足，维持当前监测',
            period_Insufficient1:'以下类别本期数据不足，请持续关注',
            Top_5_Positives:'表现亮点',
            Top_5_Positives_text1:'此周期内无显著优势项',
            Top_5_Positives_text2:'没有足够多的积极评论，不足以形成排名',
            Top_5_Negatives:'待提升项',
            Top_5_Negatives_text1:'此周期内无待提升项',
            Top_5_Negatives_text2:'没有足够多的消极评论，不足以形成排名',
            Friendly_staff:'友好的工作人员',
            Trend:'趋势',
            Comment:'意见',
            Trend_Insight:'洞察',
            Performance_Trend:'表现趋势',
            Expand_All:'展开全部',
            Collapse_All:'收起全部',
            totalReviews_one:"{n} 条评论",
            totalReviews_other:"{n} 条评论",
            Total_reviewsTooltip:"该数字反映了这一时期评论的总数，包括仅有评分的“极简”评论。因此，人工智能分析的评论数量可能低于此数值，导致其与总评论数存在自然差异。",
            reviewsTextAnalysed_one:"已分析 {n} 条含文字评论",
            reviewsTextAnalysed_other:"已分析 {n} 条含文字评论",
            reviewsTextAnalysedTooltip:"WTK AI 已分析的含文字评论数。仅有评分的评论没有文字可分析，所以这个数字可能低于总评论数。",
            reviewsMentionCategory_one:"已分析 {n} 条评论",
            reviewsMentionCategory_other:"已分析 {n} 条评论",
            reviewsMentionCategoryTooltip:"已分析评论中提及该类目的条数。一条评论可能同时提及多个类目，所以各类目条数相加不等于已分析总数。",

            Market_View_Competitive_Summary:'市场观点和竞争总结',
            Market:'市场',
            Competitive_Dimensions:'竞争维度',
            Execution_Signature:'执行签名',
            Experience_Boosters_By_Competitors:'竞争对手带来的体验提升',
            Guest_Desire:'客人欲望',
            Execution:'执行',
            Takeaway:'外卖',
            Operational_Challenges:'运营挑战',
            Share_Trigger_Landscape:'共享触发器环境',
            Action_Focus:'行动重点',
            Overall_Direction:'总体方向',
            Category_Solutions:'类别解决方案',
            Defensive_Offensive_Moves:'压力和竞争优势',
            Defensive_Moves:'竞争压力',
            Offensive_Moves:'竞争优势',
            Competitor_Patterns:'竞争对手模式',
            Strategic_Playbook:'战略剧本',
            Portfolio:{
                Tabs_Restaurant:'单店报告',
                Tabs_Portfolio:'聚合报告',
                Critical_Items:'紧急警示',
                Competitor_Alerts:'竞品预警',
                Cross_Outlet_Comparison:'跨餐厅类别对比',
                Category:'类别',
                Signal:'信号',
                Standout_Positive:'突出表现（正向）',
                Standout_Negative:'突出表现（负向）',
                Portfolio_Wide_Issue_Label:'跨餐厅共性问题：',
                Outlet_Digest:'各餐厅简报',
                Strength_Label:'优势：',
                Concern_Label:'问题：',
                Watch_Label:'监控：',
                Portfolio_Actions:'行动建议',
                Review_Generation_Recommendations:'评论量提升建议',
                Status_Requires_Immediate_Attention:'需要立即关注',
                Status_Monitor_Closely:'持续密切监控',
                Status_No_Action_Required:'无需行动',
                Status_Insufficient_Data:'数据不足',
                Signal_Strong:'强',
                Signal_Mixed:'混合',
                Signal_Weak:'弱',
                Signal_Insufficient_Data:'数据不足',
                Unknown_Outlet:'未知餐厅',
                Staff_Positive_Outlet_Ranking:'正向提及前十员工',
                Ranking_Staff_Name:'员工',
                Ranking_Outlet_Name:'餐厅',
                Staff_Positive_Total:'正向',
                Staff_Negative_Total:'负向',
                Staff_Mentions_Total:'总提及',
                Staff_Positive_Ranking_Empty:'本时段暂无各店动态数据。',
            },
        },
        Staff_Mentions_Leaderboard:{
            View_By_Name:'按姓名',
            View_By_Division:'按部门',
            Sentiment_All:'全部',
            title:'员工排行榜',
            empty_title:'该时间段内没有员工被提及',
            empty_hint:'可以换成更长的时间范围，例如上月或本季度。',
            Updated:'最后更新',
            Rank:'排名',
            Name:'名字',
            Last_mention:'最后提及',
            Total_mentions:'总提及次数',
            MoM:'环比上月',
            Positive:'积极',
            Negative:'消极',
            Positive_Ratio:'正比',
            Review_date:'评论日期',
            Show_More:'显示更多',
            Show_All:'显示全部',
            Show_Less:'显示更少',
            MTD:'本月至今',
            Finalized:'已完结',
            Export_CSV:'导出 CSV',
            Export_Type:'类型',
            Export_Source:'来源',
            Export_Reviewer:'评论人',
            Export_Mention_Sentiment:'该次提及情感',
            Export_Evidence:'证据原文',
            Export_Review:'评论正文',
            Export_Review_Link:'评论链接',
            popoverTitle:'提示:',
            popoverText:"此评分为 WQI，采用1-10分制，可能与客人评论来源的原始评分存在差异。",
        },
        LastWeekTopLists:{
            title:'上周热门榜单',
            Type:'类型',
            Positive:'提到优点',
            Negative:'提到问题',
            emptyState:'暂无数据，请检查上周是否有足够的评论。',
            notEnoughWritten:'上周带文字的评论太少，无法生成榜单。仅评分的评论没有可分析的文字。',
            generating:'上周榜单正在生成，请稍后再来查看。',
        },
        Activity24h:{
            title:'最近动态',
            past24h:'实时',
            review:'条评论',
            reviews:'条评论',
            analysed:'已分析',
            reviewDetails:'评论详情',
            positiveReviews:'好评',
            negativeReviews:'差评',
            positive:'提到优点',
            negative:'提到问题',
            positiveLower:'好评',
            negativeLower:'差评',
            withContent:'含文字评论',
            ratingOnly:'仅评分',
            sentiment:'情感',
            contentLabel:'内容',
            riskSignals:'风险信号',
            noReviews:'最近 72 小时内没有新评论。',
            monitoring:'监控继续进行中。',
            viewMore:'查看更多',
            viewLess:'收起',
            noMatchingReviews:'未找到匹配的评论。',
            emptyPositive:'最近动态中暂无明显好评信号',
            emptyNegative:'最近动态中暂无明显差评信号',
            wtkScoreLabel:'WQI',
            syncHint:'新评论分析后会即时显示于此，受平台同步时效影响可能略有延迟。',
            riskSignalLabels:{
                extremely_low:'评分预警',
                negative_only:'仅负面反馈',
                rating_discrepancy:'评分不匹配',
            },
            riskSignalTooltips:{
                extremely_low:'评分达到或低于您自定义预警阈值的评论。您可以在设置中配置该阈值，以监控需要关注的评论。',
                negative_only:'仅负面评价表示该评论不含任何正面内容，仅包含负面反馈，与整体评分无关。',
                rating_discrepancy:'评分不匹配表示访客评分与AI情感分析结果存在明显差异。例如评分较高但书面内容以负面为主，或反之。',
            },
            reviewSummary:'摘要',
            guestRating:'客人评分',
            guestReview:'客人评论',
            openOriginalReview:'查看原始评论',
            relatedReview:'条相关评论',
            nightUnit:'晚',
        },
        RoomTypeBreakdown:{
            rtbTitle:'房型',
            positive:'正面',
            negative:'负面',
            total:'总计',
            showing:'显示 {visible} / {total}',
            popover:'在共 {total} 条评论中，有 {identified} 条能识别出房型（覆盖率 {coverage}%）。多数 Google 与 TripAdvisor 评论不包含房型信息。',
            filterAll:'全部',
            empty:'该时间段内未找到与房型相关的数据。',
            positiveMentions:'正面提及',
            negativeMentions:'负面提及',
            relatedReview:'条相关评论',
            expandMore:'+{count} 更多',
            collapse:'收起',
        },
    },
    RestaurantDashboard:{
        title:'餐厅运营仪表盘',
        Platform_Overview:{
            title:'1. 平台概览',
            tooltip1:'回复率和平均回复时间为样本数据，接入集成后系统将显示真实数据。',
        },
        Performance_Analytics:{
            title:'2. 绩效分析',
        },
        Selected_Restaurant:'选择餐厅',
        Performance_Highlights:'AI摘要',
        Overall_Performance:'整体表现',
        Food_Quality:'餐品质量',
        Beverage_Quality:'饮品质量',
        Service_Quality:'服务表现',
        Ambience:'环境氛围',
        Cleanliness:'卫生',
        Value_Perception:'价值感知度',
        Sarai:'Sarai',
        Istros:'Istros',
        Review_sources:'评论来源分布',
        botList:{
            Top_5_Positive_Mentions:'五大正面评价',
            Top_5_Negative_Mentions:"五大负面评论",
        },
        Food_Beverage_Mentions_Leaderboard:'餐饮提及排行榜',
        Food:"食物",
        Beverage:"饮料",
        Show_all:"展示全部",
        LastMonthTopLists:{
            title:'上月热门榜单',
            Type:'类型',
            Positive:'提到优点',
            Negative:'提到问题',
            emptyState:'暂无数据，请检查上月是否有足够的评论。',
            notEnoughWritten:'上月带文字的评论太少，无法生成榜单。仅评分的评论没有可分析的文字。',
            generating:'上月榜单正在生成，请稍后再来查看。',
        },
    },
    ReviewsTitle:{
        // WTK-727: publish a reply on Google
        PostToGoogle: "发布到 Google",
        PostToGoogleConfirm: "这条回复将以商家身份公开发布在 Google 上这条评论下。确定现在发布吗？",
        PostToGoogleConfirmButton: "发布",
        PostToGoogleCancel: "取消",
        PostedToGoogle: "已发布到 Google",
        PostToGoogleFailed: "发布到 Google 失败",
        // WTK-730: preview before posting, edit a reply on Google
        EditOnGoogle: "在 Google 上修改",
        UpdateOnGoogleConfirm: "下面的内容会替换你在 Google 上的现有回复。确定保存吗？",
        SaveToGoogle: "保存到 Google",
        UpdatedOnGoogle: "已在 Google 上更新回复",
        // WTK-820: who replied from WhereToKnow
        ReplyLogPosted: "{name} 通过 WhereToKnow 发布到 Google · {time}",
        ReplyLogEdited: "{name} 通过 WhereToKnow 修改了 Google 上的回复 · {time}",
        ReplyLogFailed: "{name} 发布到 Google 失败 · {time}",
        ReplyLogShow: "查看记录（{n}）",
        ReplyLogHide: "收起记录",
        ReplyLogSomeone: "一位同事",
        // WTK-743: reply on Tripadvisor through its Management Center
        ReplyOnTripadvisor: "在猫途鹰回复",
        TripadvisorReplyCopied: "回复已复制。请在打开的 Tripadvisor 页面粘贴并提交（需用门店管理员账号登录），Tripadvisor 审核后会公开。",
        TripadvisorReplyCopyFailed: "已打开 Tripadvisor，但回复没能自动复制，请在这里手动复制。",
        title:'评论与回复',
        avgResponseTime:"平均响应时间",
        Unreplied:"未回复:",
        Flagged:"已标记:",
        ScoreColorGuide:'分数颜色指南',
        Business_Traveller:'商务旅客',
        placeholder1:"选择语言",
        Translation:"翻译",
        Translating:"翻译",
        Original:"原文",
        GuestUser:"匿名用户",
        Stay:"入住日期:",
        Review:"评论日期:",
        GoToTheReview:"转到评论",
        Search_Match_Count:"匹配评论 {count} 条",
        Search_Match_Summary:"共 {mentions}，分布在 {reviews} 中",
        Search_Mentions_Count:"{n} 次提及",
        Search_Reviews_Count:"{n} 条评论",
        Search_Sort_Mentions:"提及",
        Search_Sort_Mention_Asc:"提及次数 少→多",
        Search_Sort_Mention_Desc:"提及次数 多→少",
        Search_Sort_Default:"默认排序",
        Review_Keyword_Mentioned:"该评论被提及 {count} 次",
        ReadMore:"阅读更多",
        ShowLess:"显示更少",
        text4:"类型比例",
        text5:"AI回复",
        text51:"回复",
        text6:"生成",
        text7:"编辑",
        text8:"发送",
        Reply:'回复',
        Copy:'复制',
        Replied:'已回复',
        Forward:'转发',
        ForwardTo:'转发给',
        ForwardCancel:'取消',
        ForwardSend:'发送',
        ForwardNoStaff:'暂无员工',
        ForwardNoPermission:'你没有查看员工列表的权限，请联系本酒店的管理员。',
        ForwardUseWtk:'使用 WTK 发送',
        ForwardNotePlaceholder:'说明为什么要把这条评论转发给同事……（选填）',
        ForwardSendViaWtk:'通过 WTK 发送',
        ForwardSending:'发送中……',
        ForwardSent:'已通过 WTK 发送',
        Ratings_only:'仅有评分',
        Ratings_only_tooltip:'该住客只打了分，没有写评论内容，所以没有可供 AI 分析的文字。',
        filters:{
            title:'评论筛选',
            Review_Mode:'分析模式',
            Review_Mode1:'客人原始打分',
            Score_Scale_Note:'按 10 分制筛选，5 星制平台的分数乘以 2（5 星 = 10 分）。',
            Review_Mode2:'AI分析得分',
            Review_ModeNote:'信息说明',
            Review_ModeNote1:'仅显示包含文本内容的评论（没有文字的评论已被隐藏）',
            Review_Type:'评论类型',
            Review_Type1:'所有评论',
            Review_Type2:'含文本',
            Review_Type3:'仅有评分',
            Review_Type1_disabled:'"仅含文本"模式下不可用。',
            Sentiment_Status:'情感状态',
            Source_Language:'评论语种',
            Source_Language_Placeholder:'全部语种',
            Summary_Type:'评价倾向',
            Summary_TypeObj:{
                IncludePositive:'含正面',
                IncludeNegative:'含负面',
                PositiveOnly:'仅正面',
                NegativeOnly:'仅负面',
            },
            Review_Status:'评论状态',
            Review_StatusLabels:[
                {
                    label:'积极',
                    value:'Positive',
                },
                {
                    label:'消极',
                    value:'Negative',
                },
                {
                    label:'评分不匹配',
                    value:'RatingDiscrepancy',
                },
            ],
            Categories:'分类',
            Sort:'排序',
            Sort_By:'排序方式',
            Sort_Time:'时间',
            Sort_Score:'评分',
            Sort_Weight:'权重',
            Sort_Time_Newest:'最新优先',
            Sort_Time_Oldest:'最早优先',
            Sort_Score_High:'从高到低',
            Sort_Score_Low:'从低到高',
            Sort_Weight_Highest:'权重最高',
            sortObj:{
                'Time (newest first)':'按时间（从新到旧）',
                'Time (oldest first)':'按时间（从旧到新）',
                'Score (high to low)':'按评分（从高到低）',
                'Score (low to high)':'按评分（从低到高）',
                'Weight (highest first)':'类别权重（从高到低）',
            },
            Reply_Status:'回复状态',
            Reply_StatusObj:{
                'Replied':'已回复',
                'Pending':'未回复',
            },
            Apply:'应用',
            Cancel:'取消',
            Reset:'重置',
            Status:'状态',
            Status_Labels:[
                {
                    label:'预设回复',
                    value:'SavedReply',
                },
                {
                    label:'备注',
                    value:'WithNotes',
                },
            ],
            Meal_Time:'用餐时段',
            mealTime:{
                Lunch:'午餐',
                Dinner:'晚餐',
                Brunch:'早午餐',
                LUNCH:'午餐',
                DINNER:'晚餐',
                BRUNCH:'早午餐',
                BREAKFAST:'早餐',
                OTHER:'其他',
            },
            Dining_Mode:'用餐方式',
            diningMode:{
                DineIn:'堂食',
                TakeOut:'外带',
                DINE_IN:'堂食',
                TAKE_OUT:'外带',
            },
            Experience_Attributes:'体验属性',
            experienceAttr:{
                NoiseLevel:'噪音水平',
                Quiet:'安静',
                Moderate:'适中',
                Loud:'嘈杂',
                QUIET:'非常安静',
                MODERATE:'噪音适中',
                LOUD:'较吵，但仍可交谈',
                NOT_SURE:'不确定',
                GroupSize:'用餐人数',
                Solo:'单人',
                Couple:'双人',
                SmallGroup:'小型聚餐',
                LargeGroup:'大型聚餐',
                SOLO:'1人',
                COUPLE:'2人',
                SMALL_GROUP:'3-4人',
                LARGE_GROUP:'5-8人',
                ALL:'适合所有人数',
                SeatingType:'座位类型',
                Indoor:'室内',
                Outdoor:'室外',
                Bar:'吧台',
                INDOOR:'室内用餐区',
                OUTDOOR:'户外露台/庭院',
                BAR:'吧台区域',
                BOOTH:'卡座',
                COUNTER:'柜台座位',
                PRIVATE:'包间',
            },
        },
        Guest_Tags:'客人标签',
        contextKeys:{
            'Noise level':'噪音水平',
            'Group size':'用餐人数',
            'Seating':'座位类型',
            'Dinner size':'用餐人数',
            'Meal type':'用餐时段',
            'Order type':'用餐方式',
            'Price per person':'人均消费',
            'Parking space':'停车空间',
            'Parking options':'停车选项',
            'Kid-friendliness':'儿童友好度',
            'Vegetarian options':'素食选择',
            'Wheelchair accessibility':'轮椅无障碍',
            'Wi-Fi':'Wi-Fi',
            'Outdoor seating':'户外座位',
            'Live music':'现场音乐',
            'Private dining':'包间',
            'Reservation':'预订',
            'Wait time':'等待时间',
            'Service options':'服务选项',
            'Highlights':'特色亮点',
            'Atmosphere':'氛围',
            'Popular for':'适合场景',
            'Accessibility':'无障碍设施',
            'Amenities':'设施',
            'Crowd':'客群',
            'Planning':'规划',
            'Payments':'支付方式',
            'Dining options':'用餐选项',
            'Offerings':'提供项目',
            'Children':'儿童相关',
            'Seating type':'座位类型',
            'Noise Level':'噪音水平',
            'Group Size':'用餐人数',
            'Food':'食物',
            'Beverage':'饮品',
            'Service':'服务',
            'Atmosphere':'氛围',
            'Cleanliness':'清洁',
            'Value':'价值',
            'Location':'位置',
            'Accessibility':'无障碍设施',
            'Amenities':'设施',
        },
        contextValues:{
            'Yes':'是',
            'No':'否',
            'Plenty of parking':'充足的停车位',
            'Free parking lot':'免费停车场',
            'Paid parking lot':'付费停车场',
            'Street parking':'路边停车',
            'No parking':'无停车位',
        },
        noReviews1:'所选期间/来源没有评论，请重置',
        noReviews2:'筛选并重试',
        WTKscore:'WQI:',
        WTKscore1:'基于先进的人工智能情感分析及酒店专家贡献计算得出，评分范围为1至10分。对于原始采用1至5分量表的来源（如谷歌），已将其转换为1至10分量表，以确保所有平台评分的公平可比性。',
        Note:"提示",
        NoteText:"本条评论没有具体的内容。因此AI生成的回复无法针对特定的评论细节，而是仅对客人打分作出通常性的回应。",
        NoteText1:"该条评论正在分析中。分析结果准备就绪后，回复界面将自动开启。",
        Summary:'评论摘要',
        LoadTheCommentData:'加载评论数据',
        CategoryWeight:'评论维度',
        CopyAllSections:'复制所有部分',
        showTranslatedContent:"复制所有部分当前回复没有翻译数据，单击以稍后翻译。",
        showOriginalContent:'当前回复没有“原始”数据，单击以进行翻译。',
        Pending_analysis:'待分析',
        Pending_analysis_tooltip:'该评论目前正根据酒店类别基准进行分析，结果即将显示',
        Pending_analysis_tooltip1: '本条评论超出您当前订阅计划的时间范围，如需扩大分析范围，请与我们联系。',
        Reply_pending_tooltip:'该评论分析完成后即可回复',
        Rating_discrepancy:'评分不匹配',
        Rating_discrepancy_tooltip:'本条评论的语义分析和用户评分结果存在差异，需要管理团队给予更多关注。',
        // 评论 AI 分析为空、分数改用平台评分时，分数旁的标签和悬停文字（WTK-792）
        Platform_rating:'平台评分',
        Platform_rating_tooltip:'暂无 AI 分析结果，当前显示的是平台评分。',
        Rating_mismatch_single:'{dimensions}评分不匹配',
        Rating_mismatch_multi:'{dimensions}不匹配',
        Discrepancy_dimension:{
            Service:'服务',
            Food:'食物',
            Atmosphere:'氛围',
            Beverage:'饮品',
            Cleanliness:'清洁',
            Value:'价值',
        },
        Unknown:'未知',
        Switch_to_list_mode:'切换至列表模式',
        Switch_to_preview_mode:'切换至预览模式',
        Export_Excel:'导出 Excel',
        // WTK-573 筛选栏图标说明 / 重置按钮
        Filters_Tip:'筛选',
        Filters_Active_Tip:'筛选（已有条件生效）',
        Search_Tip:'搜索',
        Reset_Filters:'重置',
        Keyword_Search_Placeholder:'搜索评论内容…',
        Filter_Sheet_Period:'时间段',
        Filter_Sheet_Keyword:'搜索关键字',
        Expand:'展开',
        Collapse:'折叠',
        Has_internal_note:'有内部备注',
        This_reviews_has_been_saved:'这条评论已保存',
        Note_deleted:'备注已删除',
    },
    Replies:{
        title:'回复规则设置',
        Hotel_Name_Usage:{
            title:'酒店署名设置',
            title1:'酒店署名',
            input1:'输入酒店署名',
        },
        Restaurant_Name_Usage:{
            title:'餐厅名称使用',
            title1:'餐厅名称',
            input1:'输入餐厅名称',
        },
        Tone:{
            title:'回复风格及语气',
            label1:'品牌预设',
            label2:'正式程度',
            label3:'缩写',
            label4:'表情符号',
            label5:'幽默语气',
            label6:'感叹号数量限制',
            label7:'回复中显示酒店署名',
            label7_restaurant:'回复中显示餐厅署名',
            option1:[
                {
                    label:'典雅正式',
                    value:'formal_elegant',
                },
                {
                    label:'专业亲和',
                    value:'premium_warm',
                },
                {
                    label:'轻松活泼',
                    value:'casual_playful',
                },
                {
                    label:'简洁直接',
                    value:'minimal_neutral',
                },
            ],
            option2:[
                {
                    label:'中',
                    value:'medium'
                },
                {
                    label:'高',
                    value:'high'
                },
            ],
            option3:[
                {
                    label:'低',
                    value:'low'
                },
                {
                    label:'中',
                    value:'medium'
                },
            ],
            showData1:[
                '简洁:「感谢您的反馈！很高兴您在这里过得愉快。」',
                '标准:「感谢您的反馈！我们很高兴得知您在此有愉快的体验。」',
                '隆重:「我们由衷感谢您的宝贵反馈，欣闻您在此度过愉快的时光令我们十分欣喜。」'
            ],
            showData2:'我是，我是',
            showData3:'控制幽默感的强度',
            showData4:'允许的最大感叹号数量',
            showData5:'在回复中包含酒店名称（打开）或不包含（关闭）',
            showData5_restaurant:'在回复中包含餐厅名称（打开）或不包含（关闭）',
        },
        LanguageRules:{
            title:'回复语言规则',
            label1:'回复语言规则',
            label2:'书写语气',
            radio1:[
                {
                    text1:'自动',
                    text2:'（随评论语言回复）',
                    value:'auto'
                },
                {
                    text1:'固定',
                    text2:'（始终以指定语言回复）',
                    value:'fixed'
                },
            ],
            option1:[
                {
                    label:'正式',
                    value:'formal'
                },
                {
                    label:'非正式',
                    value:'informal'
                },
            ],
            alertTitle:'提示',
            alertData:'如果您选择“强制指定”，即使客人用另一种语言写评论，回复也将始终以所选语言生成。这可能看起来不一致。',
            showData1:'仅适用于带有正式或非正式代词的语言（德语、法语、意大利语、中文）',
        },
        WordPreferences:{
            title:'关键词设置',
            label1:'推荐关键词',
            label2:'屏蔽关键词',
            tagInput1:['团队','经验'],
            tagInput2:['惠顾','随函'],
        },
        Title:{
            title:'回复问候语设置',
            label1:'问候语格式',
            label2:'默认开场语',
            option1:[
                {
                    label:'您好 [用户名]',
                    value:'Hi [Username]',
                },
                {
                    label:'你好 [用户名]',
                    value:'Hello [Username]',
                },
                {
                    label:'尊敬的 [用户名]',
                    value:'Dear [Username]',
                },
                // {
                //     label:'自定义问候语',
                //     value:'Custom',
                // },
            ],
            option2:[
                {
                    label:'尊敬的客人',
                    value:'Dear Guest',
                },
                {
                    label:'你好，旅行者',
                    value:'Hello Traveler',
                },
                // {
                //     label:'自定义问候语',
                //     value:'Custom',
                // },
            ],
        },
        MainBody:{
            title:'正文',
            title1:'智能回复',
            label1:'回复内容',
            label2:'类别',
            label3:'主题标签',
            label4:'触发关键词',
            label5:'操作',
            button1:'添加新的智能回复',
            emptyText:'+ 添加您的第一条智能回复',
            showData1:'智能回复会根据关键词和语义匹配自动触发，每条只会出现一次',
            placeholder3:"创建主题标签",
            placeholder4:"搜索或添加选项",
            placeholder5:"+添加",
            delTitle:'删除确认',
            delTitleTooltip:'删除后数据将不可恢复。请谨慎行事。',
            cancelBtn:'取消',
            delBtn:'删除',
            SaveTitle:'保存修改',
            SaveTitleTooltip:'修改后的内容尚未保存。是否要保存？',
            Do_not_save:'不保存',
            Do_not_save1:'放弃更改',
            Save:'保存',
        },
        Ending:{
            title:'回访与签名',
            label1:'回访邀请策略',
            label2:'署名',
            radio1:[
                {
                    text1:'全部邀请',
                    text2:'每个回复都包含一个返回的邀请',
                    value:"always_invite_back"
                },
                {
                    text1:'正面/中性反馈时的邀请',
                    text2:'只有当客人的评论是积极的或中立的时才邀请',
                    value:"invite_on_positive_or_mixed_feedback"
                },
                {
                    text1:'智能邀请（AI 决定）',
                    text2:'AI 将做出决定；在明显负面的情况下没有邀请',
                    value:"smart_invite"
                },
            ],
            placeholder1:"在此处添加团队或经理署名",
            placeholder2:'示例:"维也纳酒店", "值班经理王先生"',
        },
        ReplyLength:{
            title:'回复长度',
            radio1:[
                {
                    text1:'短文（30-60字）',
                    text2:' (快速简单：适用于OTA平台)',
                    value:"short",
                },
                {
                    text1:'标准（60-100字）',
                    text2:' (平衡和专业：推荐默认值)',
                    value:"standard",
                },
                {
                    text1:'详细（100-140字）',
                    text2:' (更全面、更具叙述性；非常适合官方网站或电子邮件回复)',
                    value:"detailed",
                    showTooltip: true
                },
                {
                    text1:'动态（AI 自动调整）',
                    text2:' (长度灵活；适应客人的评价)',
                    value:"dynamic",
                },
            ],
        },
        button1:'预览',
        button2:'保存设置',
        Preview:{
            title:'预览',
            label1:"标题",
            label2:"开始",
            label3:"正文",
            label4:"结局",
            button1:'取消',
            button2:'确认',
        },
        notes:{
            Notes:'备注',
            internal:'内部',
            No_internal_notes_yet:'目前尚无内部注释。',
            Add_note:'添加备注',
            Only_visible_to_your_team:'仅对您的团队可见',
            placeholder:'为这条评论添加分析、处理说明或后续行动…',
            Cancel:'取消',
            Save:'保存',
            Delete:'删除',
            Edit:'编辑',
            Delete_Text:'数据删除后将无法恢复。请谨慎操作。',
            Delete_note:'删除备注',
        },
        Reply_Saved:'回复已保存',
        Reply_Saved_text:'您的回复已保存。您可在“回复库”部分找到它。',
    },
    competitors:{
        title:'竞争对比',
        title1:'选择酒店：',
        title1_restaurant:'选择餐厅：',
        title2:'OTA平台平均得分',
        title3:'酒店整体',
        title31:'酒店独立得分',
        title31_restaurant:'餐厅独立得分',
        Relative_Performance:'竞对分数比较',
        Relative_Performance_tooltip_title:'提示: ',
        Relative_Performance_tooltip:'相对绩效指数是通过将您的独立总分除以竞争对手的平均分计算得出。数值低于1.0表示您的表现低于竞争对手平均水平，而数值高于1.0则表示您的表现优于竞争对手平均水平。',
        Under_performance:'表现不佳',
        Over_performance:'超常发挥',
        label3_1:'您的酒店整体',
        label3_1_restaurant:'您的餐厅整体',
        title4:'竞争对手',
        title5:'分数概述',
        'score':'总分',
        'Total_reviews':'总评价数',
        'location_neighbourhood':'地理位置',
        'cleanliness':'卫生',
        'room_comfort':'客房舒适度',
        'hotel_amenities_atmosphere':'酒店设施与氛围',
        'food_beverage':'餐饮',
        'guest_experience_service':'服务体验',
        'value_for_money':'性价比',
        'food_quality':'食品质量',
        'beverage_quality':'饮品质量',
        'service_quality':'服务质量',
        'ambience':'氛围',
        'value_perception':'价值感知',
        'your_hotel':'您的酒店',
        // 手机：OTA 平台平均得分（按平台切换的排名列表）
        ota_reviews:'{n} 条评价',
        ota_vs_you_up:'比本店高 {n}',
        ota_vs_you_down:'比本店低 {n}',
        ota_vs_you_same:'与本店持平',
        ota_no_score:'暂无评分',
        ota_platforms:'平台',
        // 手机分析区筛选入口：「上月 · 6 家酒店」
        hotels_count:'{n} 家酒店',
        restaurants_count:'{n} 家餐厅',
        averageTooltip:'除您酒店外的竞争酒店平均得分',
        diffTooltip:'您酒店该项评分与竞争对手该项平均分之间的差异',
        title6:'类别:',
        lowSampleTooltip:'低样本 (n={n}) —— 仅供方向参考,不具统计可靠性',
        wow:{
          title:'周环比变化',
          tooltip:'将当前周期与上一个等长周期对比。样本量低于 10 的酒店,变化值以浅色显示 —— 仅供方向参考,不具统计可靠性。',
          colHotel:'酒店',
          colRestaurant:'餐厅',
          lastWeek:'上周',
          thisWeek:'本周',
          change:'变化',
          you:'本店',
          lowSample:'低样本 (n={n}) —— 变化值仅供方向参考',
        },
        title61:'类别表现',
        compareLabel:'对比周期',
        compareStartPlaceholder:'开始日期',
        compareEndPlaceholder:'结束日期',
        compareVs:'对比',
        compareSamePeriodHint:'请选择不同的对比时间',
        viewPrevPeriodReviews:'查看对比周期评论',
        compare:'对比',
        bySentiment:'按情感',
        byCategory:'按分类',
        topic:'主题',
        review:'评论',
        byTopic:'按主题',
        byNumber:'按数量',
        period:'对比周期',
        previousValueLabel:'对比周期',
        currentValueLabel:'本期',
        changeLabel:'变化',
        title7:'总结',
        label7_1:'亮点',
        label7_2:'建议',
        label7_3:'问题',
        title8:'客户旅程',
        title9:'评论来源分布',
        title9_1_1:'评论来源分布',
        label9_1:'社交媒体',
        label9_2:'预览模式',
        title10:'社交媒体平台',
        label10_1:'总互动量',
        title11:'国家 / 地区',
        title12:'旅客类型',
        My_Top_5_Markets:'我的五大市场',
        My_Top_5_Markets_Tooltip:'每家酒店的占比独立计算，非累计总和',
        Competitors_Top_5_Markets:'竞争对手的五大市场',
        Competitors_Top_5_Markets_Tooltip:'竞争对手酒店的客人份额比您的酒店高出10%以上的国家',
        Source_Filter_Placeholder:'来源：全部',
        Source_All_Option:'全部来源',
        Market_Overlap:'市场重叠',
        Dominant_Markets:'主导市场',
        Missed_Opportunities:'错失的机会',
        Average_of_competitors:'竞争对手的平均值',
        echarts2Tooltip:'各酒店该国客人占比(不可累计)：',
        Insight_Box:'洞察盒',
        Insight_Box_text:'与竞争对手相比，您的酒店吸引了更多的家庭（32%）和情侣（28%）游客，而商务客人较少。',
        no_Data_Tooltip:'该酒店在所选期间内没有与该类别相关的数据。',
        Sentiment_Evolution:'分数趋势',
        competitor_avg:'竞争对手均值',
        ScoreTrend_Compare:'对比',
        ScoreTrend_None:'无',
        ScoreTrend_PreviousPeriod:'上一周期',
        ScoreTrend_LastMonth:'上月',
        ScoreTrend_SamePeriodLastYear:'去年同期',
        ScoreTrend_CustomRange:'自定义范围',
        ScoreTrend_CurrentRange:'当前范围',
        ScoreTrend_CompareRange:'对比范围',
        ScoreTrend_Current:'当前',
        ScoreTrend_CompareSeries:'对比',
        ScoreTrend_ScoreBelowThreshold:'低于阈值',
        ScoreTrend_CurrentAvg:'当前均值',
        ScoreTrend_CompareAvg:'对比均值',
        ScoreTrend_Difference:'差值',
        ScoreTrend_PercentChange:'变化百分比',
        ScoreTrend_NoComparisonData:'暂无对比数据',
        ScoreTrend_VsPreviousPeriod:'对比上一周期',
        ScoreTrend_VsLastMonth:'对比上个月',
        ScoreTrend_VsLastYear:'对比去年同期',
        ScoreTrend_VsCustomRange:'对比自定义范围',
        ScoreTrend_LastMonthNote:'均值按完整自然月统计；趋势图仅展示重叠日期。',
        ScoreTrend_Apply:'应用',
        ScoreTrend_Back:'返回',
        // 评论证据抽屉（CompetitorCategoryDrawer）里按大类分组的短名
        topicShort:{
            Location:'位置',
            Cleanliness:'清洁',
            Room:'客房',
            Atmosphere:'氛围',
            FB:'餐饮',
            Service:'服务',
            Value:'性价比',
            Other:'其他',
        },
    },
    StaffManagement:{
        title:'员工管理',
        addStaff:'添加员工',
        email:'邮箱',
        username:'用户名',
        name:'姓名',
        role:'角色',
        status:'状态',
        actions:'操作',
        editRoles:'编辑角色',
        edit:'编辑',
        // 手机列表「更多」菜单：只能查看的账号（集团账号、自己）用这个代替「编辑」
        viewDetails:'查看详情',
        department:'部门',
        departmentPlaceholder:'请选择部门',
        allDepartments:'全部部门',
        post:'职位',
        postPlaceholder:'请输入职位（如：前厅经理）',
        suspend:'停用',
        delete:'删除',
        active:'已启用',
        suspended:'已停用',
        confirmSuspendTitle:'停用该员工？',
        confirmSuspendBody:'停用后该员工将无法登录，可随时重新启用。',
        confirmDeleteTitle:'将该员工移出本门店？',
        confirmDeleteBody:'移出后对方将无法再访问本门店，此操作无法撤销。',
        cancel:'取消',
        confirm:'确认',
        save:'保存',
        emailPlaceholder:'例如 name@yourhotel.com',
        rolesPlaceholder:'请选择角色',
        searchPlaceholder:'搜索姓名、邮箱或角色',
        statusAll:'全部',
        noStaff:'暂无员工',
        addSuccess:'添加成功',
        suspendSuccess:'已停用',
        deleteSuccess:'已移出',
        rolesUpdateSuccess:'角色已更新',
        loadFailed:'加载失败，请重试',
        emailRequired:'请输入邮箱',
        invalidEmail:'请输入有效的邮箱地址，例如 name@yourhotel.com',
        emailExists:'该邮箱已在员工列表中',
        addFailed:'添加失败，请重试',
        actionFailed:'操作失败，请重试',
        currentUser:'当前账号',
        you:'我',
        cannotChangeSelf:'不能修改、停用或删除自己的账号',
        lastAdmin:'本酒店至少要保留一个在用的管理员',
        noPermissionTitle:'只有管理员可以管理员工',
        noPermissionDesc:'如需添加或调整员工，请联系本酒店的管理员。',
        updateSuccess:'已保存',
        rolesRequired:'请选择一个角色',
        staffTitle:'员工',
        peopleCount:'{n} 人',
        inviteStaff:'邀请员工',
        sendInvite:'发送邀请',
        saveChanges:'保存修改',
        close:'关闭',
        removeFromProperty:'移出本门店',
        permissionsCount:'{n} 项权限',
        whatRoleCanDo:'{role}可以做什么',
        compareRoles:'对比角色',
        currentRole:'当前角色：{role}。在上面选一个角色即可更改。',
        noRoles:'暂无可选角色',
        rolesTitle:'角色与权限',
        rolesIntro:'各角色在本门店可以做什么。',
        permissionsIncluded:'包含的权限数',
        included:'包含',
        notIncluded:'不包含',
        scope:'范围',
        lastLogin:'最近登录',
        scopeProperty:'本门店',
        scopeBrand:'品牌',
        scopePortfolio:'区域',
        groupTag:'集团',
        groupCount:'{n} 个集团账号',
        groupNote:'集团账号可以访问多家门店，由 Where to know 开通，在这里只能查看。',
        // 集团账号详情抽屉（只读）
        accessibleProperties:'可访问的门店',
        propertyCount:'{n} 家门店',
        propertyListPending:'门店名单暂未提供。',
        neverActive:'从未登录',
        // 同一组几个权限之间的分隔符
        listSeparator:'、',
        // 权限显示名，键是权限代码（后端 labelEn / labelZh 是技术名，这里写给酒店用户看的说法）
        perm:{
            READ_DASHBOARD:'查看总览',
            READ_REVIEW:'查看评论',
            READ_NEED_ATTENTION:'查看案例',
            MANAGE_NEED_ATTENTION:'处理案例',
            READ_REPLY_LIBRARY:'查看回复库',
            MANAGE_REPLY_LIBRARY:'编辑回复库',
            READ_REPLY:'查看回复设置',
            MANAGE_REPLY:'编辑回复设置',
            READ_COMPETITORS:'竞品总览',
            READ_COMPETITORS_REVIEW:'竞品评论',
            READ_REPORT:'查看报告',
            EXPORT_REPORT:'下载报告 PDF',
            EXPORT_REPORT_EXCEL:'导出数据（Excel）',
            READ_SURVEY:'查看调查',
            MANAGE_SURVEY:'处理调查',
            AI_CHAT:'AI 对话',
            READ_GOAL:'查看目标',
            MANAGE_GOAL:'编辑目标',
            MANAGE_OVERALL_SETTING:'通知',
            WEBSITE_WIDGET:'网站 Widget',
            READ_STAFF:'查看员工',
            MANAGE_STAFF:'员工管理',
            MANAGE_DEPT:'部门管理',
        },
        // 角色名，键是角色代码 _STAFF_ 后面那段（德 / 意界面也用英文名）
        roleName:{
            ADMIN:'管理员',
            MANAGER:'经理',
            GUEST_RELATIONS:'宾客关系',
            VIEWER:'查看者',
        },
        // 角色说明（后端 description 只有英文），键是角色代码 _STAFF_ 后面那段
        roleDesc:{
            ADMIN:'全部权限，包括员工、平台连接和网站 Widget。',
            MANAGER:'可查看所有数据、管理运营设置；不能管理员工和平台连接。',
            GUEST_RELATIONS:'日常处理评论、案例和调查。',
            VIEWER:'仅可查看，可下载报告；不能编辑或导出数据。',
        },
        // 权限分组（/staff/roles 的 groupName）的显示名
        groups:{
            Overview:'总览',
            Reviews:'评论',
            Cases:'案例管理',
            Replies:'回复设置',
            Competition:'竞品',
            Reports:'报告',
            Surveys:'调查',
            Other:'智能',
            Goals:'目标',
            Settings:'设置',
            Staff:'员工',
        },
    },
    Departments:{
        title:'部门管理',
        addDepartment:'添加部门',
        editDepartment:'编辑部门',
        addSub:'添加子部门',
        edit:'编辑',
        delete:'删除',
        name:'部门名称',
        namePlaceholder:'请输入部门名称',
        parent:'上级部门',
        topLevel:'无（顶级部门）',
        manager:'负责人',
        managerPlaceholder:'请选择负责人',
        updatedBy:'最近修改人',
        actions:'操作',
        noDepartments:'暂无部门',
        cancel:'取消',
        confirm:'确认',
        save:'保存',
        confirmDeleteTitle:'删除该部门？',
        confirmDeleteBody:'删除后无法恢复，请谨慎操作。',
        confirmDeleteBodyWithChildren:'该部门下还有子部门，删除后无法恢复，请谨慎操作。',
        addSuccess:'部门已添加',
        updateSuccess:'部门已更新',
        deleteSuccess:'部门已删除',
        loadFailed:'加载失败，请重试',
        saveFailed:'操作失败，请重试',
        nameRequired:'请输入部门名称',
    },
    Settings:{
        title:'系统设置',
        left1:'用户',
        left2:'目标',
        left3:'通知',
        left4:'Widget',
        left5:'平台连接',
        left6:'员工',
        left7:'部门',
        left8:'角色与权限',
        teamGroup:'团队',
        Widget:{
            title:'评价 Widget',
            desc:'将 WQI 嵌入任何网站。客户粘贴一段代码即可，无需其他依赖。',
            activeWidgets:'当前已启用的 widget',
            createNew:'创建新 widget',
            style:'样式',
            styleCompact:'页脚 / 徽章',
            styleHorizontal:'横幅条',
            styleCard:'完整分类',
            styleDark:'深色叠加',
            period:'评价时间段',
            period3m:'过去 3 个月',
            period12m:'过去 12 个月',
            periodAll:'全部',
            brandColor:'品牌色',
            custom:'自定义颜色',
            domains:'允许域名',
            domainsHint:'留空则允许所有域名。',
            domainsPlaceholder:'例如 yourhotel.com',
            generate:'生成嵌入代码',
            readyTitle:'Widget 已生成',
            readyDesc:'复制下方代码，粘贴到网站 <body> 任意位置即可。',
            copy:'复制代码',
            copied:'已复制！',
            revoke:'撤销',
            revokeConfirm:'撤销此 widget？使用此嵌入代码的客户将看不到 widget。',
            revokeSuccess:'已撤销。',
            createError:'创建失败，请重试。',
            createdAt:'创建于',
            platformScores:'平台分数（OTA）',
            platformScoresHint:'选择要在 Widget 中显示各平台独立评分的来源。',
            categories:'评分维度',
            categoriesHint:'选择要显示的维度，不选则显示全部。',
            livePreview:'实时预览',
            previewNote:'预览使用示例数据，实际数据以酒店真实评分为准',
            selectAll:'全选',
            clearAll:'清空',
            noHotel:'请先选择酒店。',
        },
        User:{
            label1:'登录详细信息',
            label2:'更改密码',
            label3:'当前密码',
            label4:'新密码',
            label5:'确认新密码',
            prompt1:'密码要求:',
            prompt2:'确保它至少有8个字符长',
            prompt3:'必须包含一个数字、一个大写字母和一个小写字母。',
            button1:'更改密码',
        },
        Goals:{
            title:'目标',
            label1:'类别',
            label2:'得分',
            label3:'目标值',
            label4:'差别',
            label5:'截止日期',
            label6:'倒计时',
            days:"天",
            unsaved:"您有未保存的更改",
            cancel:"取消",
            notSet:"未设置",
            setGoal:"设置目标",
            clearGoal:"清除",
            // 手机宽度紧凑表格：目标值单元格「设置」、编辑行的「保存」
            set:"设置",
            save:"保存",
            goalReference:"参考值 {value}",
        },
        Notifications:{
            title:'通知设置',
            enableLabel:'启用邮件通知',
            enableDesc:'当选定的评论条件被触发时，接收邮件提醒。',
            otaAlertTitle:'OTA 评分提醒',
            otaTitle:'OTA 评分阈值',
            otaDesc:'当新评论评分低于各平台设定的阈值时，接收提醒。',
            wtkTitle:'WQI 阈值',
            wtkLabel:'WQI',
            categoryTitle:'类别评分阈值',
            riskSignalTitle:'AI 风险信号提醒',
            riskSignalDesc:'当 WTK 检测到 OTA 评分中不易察觉的隐藏风险模式时，接收提醒。',
            ratingDiscrepancy:'评分不匹配',
            ratingDiscrepancyDesc:'当评论中描述的住客体验与给出的 OTA 评分不一致时触发提醒。',
            negativeOnly:'纯负面评论',
            negativeOnlyDesc:'当评论仅包含负面情感、没有正面反馈时触发提醒。',
            recipientsTitle:'通知收件人',
            emailTitle:'通知邮件收件人',
            emailPlaceholder:'输入邮箱地址',
            addEmail:'添加邮箱',
            addBtn:'添加',
            cancelBtn:'取消',
            saveBtn:'保存设置',
            invalidEmail:'请输入有效的邮箱地址',
            emailExists:'此邮箱已添加',
            reportRecipientsTitle:'报告收件人',
            reportEmailTitle:'报告邮件收件人',
            reportEmailDesc:'选择哪些人会收到定期表现报告。',
            selectFromStaff:'从员工中选择',
            noStaff:'暂无员工',
        },
    },
    Reports:{
        Performance:'表现',
        Score:'得分',
        Reviews:'评论',
        Week1:'第一周',
        Week2:'第二周',
        Week3:'第三周',
        Week4:'第四周',
        Week5:'第五周',
        Week6:'第六周',
        Avg:'平均值',
        Goal:'目标值',
        Above_Goal:'达标',
        Below_Goal:'未达标',
        Week_High:'最高',
        Week_Low:'最低',
        Week_One:'第 {n} 周',
        Week_Many:'第 {n} 周',
        Month_Avg:'{month}均分',
        Executive_Summary:'执行摘要',
        // 手机上长列表默认只显示两条，展开 / 收起；窄图表的横轴周次简写
        Show_All_N:'展开全部（{n}）',
        Show_Less:'收起',
        Week_Short:'第{n}周',
        Insufficient_Data_Title:'本期数据不足',
        Insufficient_Data_Reason:'本期评论数低于分析阈值，报告无法生成。评论数达到阈值后系统将自动生成分析。',
        // 酒店月报 Category Insights 下的脚注：月报周分数按当前分析结果重算，可能和当周周报不同（WTK-785）
        Monthly_Weekly_Scores_Note:'本月数据包含周报发出后补采或重新分析的评论，个别周的分数可能和当周周报不同。',
        competitors:{
            Executive_Competitive_Snapshot: '市场和竞争对手摘要',
            Market: '市场概述',
            Competitive_Leverage: '竞争对手酒店亮点',
            Competitive_Pressure: '竞争对手酒店问题',
            What_Management_Must_Do: '管理层应采取的行动',
            Relative_Positioning_Strengths_vs_Risks: '相对定位：我方酒店优势与风险',
            Top_Competitive_Observations: '宏观洞见',
            Top_5_Positives: '竞争优势项',
            Top_5_Negatives: '关键风险项',
            Reason: '原因',
            Competitive_Dimensions: '竞争维度分析',
            Share_Trigger_Landscape: '分享触发动因概览',
            Operational_Challenges: '运营层面挑战',
            Competitor_Patterns: '竞品共性模式',
            Overview: '概述',
            Wins: '优势项',
            Learning_Value: '学习价值',
            Frictions: '摩擦点',
            Risk_Relevancy: '风险相关性',
            Top_Mentions: '高频提及',
            Food_Mentions: '食物提及',
            Beverage_Mentions: '饮品提及',
            Cross_Competitor_Analysis: '跨竞品分析',
            Cross_Competitor_Patterns: '跨竞品模式',
            Category_Summary: '分类总结',
            Case_study_of_the_month: '案例：',
            Case_study_of_the_month_tooltip: '该竞品在此类别中最突出，可能显著强于或弱于同组其他竞品。',
            Case_study: '案例解析',
            Guest_Desire: '客人核心诉求',
            Execution: '实际执行方式',
            Takeaway: '管理要点总结',
            Best_practice: '最佳实践',
            Staff_Shortages: '人员短缺',
            Outdated_Systems: '老旧系统',
            High_Guest_Expectations: '高客户期望',
            Action_Focus: '行动重点',
            Experience_Strengths:'正向体验要素',
            Experience_Constraints:'体验摩擦点',
            Guest_Attention_Triggers:'宾客关注触发点',
            Guest_Attention_Triggers_h2:'这些因素对客人的感知和分享有着不成比例的影响',
            Guest_Attention_Triggers_empty:'本周期内未识别到该酒店的宾客关注触发点。',
            Report_Generating:'该酒店本周期的报告正在生成，生成后会自动显示在这里。',
            Report_Stalled:'报告生成时间比平时长，请过几分钟再来查看。',
            Report_Failed:'该酒店的报告加载失败。',
            Restaurant_Detail:'餐厅详情',
        },
        MoM:{
            title:'环比跟踪',
            lastMonth:'上月',
            thisMonth:'本月',
            monitorClosely:'密切关注',
            badge_new:'新增',
            badge_resolved:'信号已清除',
            badge_recurring:'持续',
            month_apr:'4月',
            month_mar:'3月',
            tracking_mock_1:'下午茶餐食评价一般；客人认为与价位相比，高端感提示不够清晰。',
            tracking_mock_2:'高峰入住时段前台欢迎体验不一致。',
            tracking_mock_3:'户外或半户外座位偶受噪音或穿堂风影响——在标识与动线优化后情绪有所改善。',
            tracking_mock_4:'个别预付外带延迟反馈——属单次运营疏漏，未见反复。',
            action_title:'行动落实跟踪',
            col_current_signal:'当前信号',
            col_last_action:'上月行动',
            effective:'有效',
            low_confidence:'低置信度',
            confidence_medium:'中置信度',
            confidence_high:'高置信度',
            empty_column:'本期暂无条目。',
            empty_solution:'暂无方案跟踪记录。',
            action_signal_1:'问题已不再出现在客人反馈中。',
            action_last_1:'个别事件——复盘外带流程并与团队确认备餐时效。',
            action_signal_2:'正面提及稳定；书面评论中未出现新的负面聚集。',
            action_last_2:'已与餐饮团队开会，沟通下午茶呈现与上菜节奏。',
            hotel_col_recurring:'反复出现的问题（{n}）',
            hotel_col_declined:'下降的客诉（{n}）',
            hotel_col_new:'新关注点（{n}）',
            hotel_rank_n:'排名 {n}',
            hotel_mock_breakfast:'早餐',
            hotel_mock_restaurant:'餐厅',
            hotel_mock_checkin:'入住',
            hotel_mock_elevator:'电梯',
            hotel_mock_billing:'账务',
            hotel_mock_price_fit:'体验与价格匹配度',
            hotel_recurring_b_apr:'热食出餐节奏仍不稳定；高峰仍有排队反馈。',
            hotel_recurring_b_mar:'高峰时段自助餐补货偏慢的多条评论。',
            hotel_recurring_r_apr:'晚餐节奏再次被提及；开放厨房附近噪音。',
            hotel_recurring_r_mar:'预订交接与等位问题仍有相似讨论。',
            hotel_declined_ci_mar:'开通快速通道后，排队与证件扫描摩擦明显减少。',
            hotel_declined_el_mar:'维保合同调整后，等候类投诉已很少见。',
            hotel_new_b_apr:'迷你吧与城市税费在账单上的新讨论聚集。',
            hotel_new_p_apr:'客人质疑本月房价档位与客房产品是否匹配。',
            hotel_solution_title:'方案跟踪',
            hotel_sol_th_category:'类别',
            hotel_sol_th_action:'行动与说明',
            hotel_sol_th_outcome:'结果',
            hotel_not_resolved:'未解决',
            still_observed:'仍在观察',
            failure_type_label:'问题标识',
            hotel_sol_parent_location:'位置与周边',
            hotel_sol_sub_accessibility:'无障碍',
            hotel_sol_1_mar:'主入口指引标识已更新；门童团队培训主动陪同。',
            hotel_sol_1_apr:'回访：路线不清的书面提及减少；继续关注接送机衔接提示。',
            hotel_sol_parent_fb:'餐饮',
            hotel_sol_sub_breakfast:'早餐运营',
            hotel_sol_2_apr:'错峰补货清单；早高峰 7–9 点增派传菜。',
            hotel_sol_parent_billing:'账务与支付',
            hotel_sol_sub_invoice:'账单准确性',
            hotel_sol_3_apr:'仍有个别重复扣款争议；财务正在复核 PMS 入账规则。',
        },
        Export_Pdf:'导出Pdf',
        Lang_Fallback:'该酒店暂无{want}报告，当前显示为{shown}。',
        Export_Pdf_Generating:'该周期的报告仍在生成中，请几分钟后再试。',
        Export_Pdf_Unavailable:'该周期的 PDF 暂时无法生成，请稍后再试。',
    },
    Brand_Overview:{
        title:'品牌概览',
        // Portfolio Insights（BrandOverview2）各竞品模块的空状态：接口没给竞品就只显示这一句，不补任何数字（WTK-753）
        noCompetitorData:'暂无竞品数据',
        All_hotels:'所有酒店',
        Portfolio_Brand:'集团 / 品牌',
        All_Brands:'所有品牌',
        Selected_hotels:'选择酒店',
        Hotel_information:'酒店信息',
        Country:'国家',
        Area:'区域',
        Address:'地址',
        Stars:'星级',
        Number_of_rooms:'房间数量',
        Status_Open:'已开业',
        Status_Opening:'即将开业',
        Ranking:{
            text1:'总体平均分',
            text2:'亚洲平均分',
            text3:'欧洲平均分',
            text4:'北美洲平均分',
            text5:' 总体得分',
            text6:' 酒店得分',
            text7:'全球排名',
            text8:'区域排名',
            average_score:'平均分',
        },
        Map_view:'全球概览',
        Competitor_score_of_OTA_platforms:'OTA评分概览',
        Total_reviews:'评论总数',
        Marriott_Member_Status_Performance:'常旅客认可度',
        Room_nights:'会员总住宿房晚',
        Reviews:'会员评论数',
        Review_Rate:'评论率',
        Status:'会员等级',
        Avg_Score:'平均得分',
        Recommend:'推荐比例',
        Ambassador:'大使',
        Titanium:'钛金',
        Platinum:'白金',
        Gold:'金卡',
        Silver:'银卡',
        Member:'会员',
        Club:'俱乐部会员',
        SilverElite:'银卡精英会员',
        GoldElite:'金卡精英会员',
        PlatinumElite:'白金卡精英会员',
        DiamondElite:'钻石卡精英会员',
        Customer_Journey:'客户旅程',
        Date:'日期',
        NovemberAvg:'11月平均值',
        RegionalAvg:'区域平均值',
        Global_Average:'全球平均值',
        Regional_Average:'区域平均值',
        Brand_consistency:'品牌一致性',
        Regional_City_Segmentation_Ranking_List:'区域/城市细分排行榜',
        Rank:'排名',
        Hotel:'酒店',
        Total_score:'总分',
        Brand_Consistency_Score:'品牌一致性得分',
        Global_Brand_Alignment_Ranking:'全球品牌一致性排名',
        Local_Cultural_Expression_Ranking:'地方文化表达排名',
        Innovation_Ranking:'创新排名',
        Elite_Recognition_Ranking:'常旅客认可度排名',
        Intention_to_Recommend_Ranking:'推荐度排名',
        CategoryLabel:[
            {
                name:"位置",
                icon:icon_Location,
                value:"Location",
            },
            {
                name:"卫生",
                icon:icon_Cleanness,
                value:"Cleanness",
            },
            {
                name:"客房",
                icon:icon_Room,
                value:"Room",
            },
            {
                name:"酒店设施",
                icon:icon_Amenities,
                value:"Amenities",
            },
            {
                name:"餐饮",
                icon:icon_FB,
                value:"F & B",
            },
            {
                name:"服务",
                icon:icon_Service,
                value:"Service",
            },
            {
                name:"性价比",
                icon:icon_Value,
                value:"Value",
            },
            {
                name:"品牌",
                icon:icon_Brand,
                value:"Brand",
            },
        ],
        Over_score:'得分',
    },
    likeTemplate:{
        total:'总数',
        dialogText:'确定取消收藏么',
        btn1:'取消',
        btn2:'确定',
        Default_reply:'默认回复',
        ScoreTemplate:{
            h1:'根据分数（1-10分）自动选择相应的回复文本',
            h1Restaurant:'根据分数（1-5分）自动选择相应的回复文本',
            h2:'每个分数都可以单独定制。所做的更改仅适用于所选分数。',
            Default:'默认回复',
            Edit:'修改',
            Reset_to_default:'恢复默认设置',
            Cancel:'取消',
            Save:'保存',
            Title:'标题',
            Start:'开始',
            Main_Body:'正文',
            Ending:'结局',
        },
        Collecting_Reviews:'收藏评论',
    },
    Survey:{
        title:'调查',
        pageTitle:'调查中心',
        overview:'概览',
        duringStay:'入住期间',
        postStay:'离店后',
        mainIssuesTop3:'Top 3 主要问题',
        sentimentSplit:'情感分布',
        aiInsightSummary:'AI 洞察摘要',
        topPositives:'表现亮点',
        topNegatives:'待提升项',
        responses:'回复',
        avg:'平均',
        tickets:'工单',
        insights:'洞察',
        recommend:'推荐',
        needAttention:'待关注',
        urgent:'紧急',
        goal:'目标',
        vsLastPeriod:'对比上周期',
        urgentOnly:'仅紧急',
        department:'部门',
        addNotes:'+ 添加备注',
        total:'总耗时',
        selectStaff:'选择员工',
        searchStaff:'搜索员工..',
        noStaffFound:'未找到员工',
        resolve:'解决',
        showMore:'查看更多',
        reviewDate:'评论日期',
        assignedJustNow:'刚刚分配',
        resolvedJustNow:'刚刚解决',
        assign:'分配',
        reassign:'重新分配',
        positive:'正面',
        neutral:'中性',
        negative:'负面',
        tab_all:'全部',
        tab_unresolved:'未解决',
        tab_assigned:'已分配',
        tab_resolved:'已解决',
        badge_urgent:'紧急',
        badge_inProgress:'处理中',
        badge_pending:'待处理',
        badge_done:'已完成',
        badge_notNeeded:'无需处理',
        dept_all:'全部',
        dept_housekeeping:'客房部',
        dept_fb:'餐饮',
        dept_frontDesk:'前台',
        dept_concierge:'礼宾',
        cat_room:'房间',
        cat_service:'服务',
        cat_fb:'餐饮',
        metric_locationNeighborhood:'位置与周边',
        metric_cleanliness:'清洁度',
        metric_roomComfort:'客房舒适度',
        metric_hotelAmenitiesAtmosphere:'酒店设施与氛围',
        metric_foodBeverage:'餐饮',
        metric_guestExperienceService:'宾客体验与服务',
        metric_valueForMoney:'性价比',
        resolveOpt_done_title:'已完成',
        resolveOpt_done_sub:'问题已解决',
        resolveOpt_notNeeded_title:'无需处理',
        resolveOpt_notNeeded_sub:'无需操作',
        time_minsAgo:'{n} 分钟前',
        time_yesterday:'昨天',
        time_daysAgo:'{n} 天前',
        time_resolvedOn:'已于 {date} 解决',
        time_assignedNMinsAgo:'{n} 分钟前分配',
        room:'房间',
        guest:'客人',
        visitor:'访客',
    },
    SurveyPostStay:{
        overallScore:'酒店独立得分',
        hotelStandaloneScore:'酒店独立得分',
        yourHotelOverall:'酒店综合得分',
        scoreRate:'调查参与度',
        responseRatio:'回复比例',
        recommendRateTitle:'推荐意愿',
        completionRate:'完成率',
        completionStats:'{completed} 已完成 • {incomplete} 未完成',
        managementResponseRate:'管理层回复率',
        replyStats:'{replied} 已回复 • {pending} 待处理',
        surveyQualityByCountries:'国家调查质量',
        surveyQualityByLanguage:'语言调查质量',
        received:'已收到',
        unreceived:'未收到',
        recommend:'推荐',
        doNotRecommend:'不推荐',
        scoreLe6:'分数 ≤ 6',
        scoreEq7:'分数 = 7',
        scoreEq8:'分数 = 8',
        scoreGe9:'分数 ≥ 9',
        mentions:'次提及',
        sampleSize:'样本量 n={n}',
        categoryShareTooltip:'该分类获得评分的回复数占全部回复总数的比例。',
        top10Countries:'国家 Top 10',
        top10Language:'语言 Top 10',
        colRank:'排名',
        colCountry:'国家',
        colLanguage:'语言',
        colScore:'分数',
        colRecommend:'推荐率',
        colNumber:'数量',
        colReceived:'收到率',
        cat_checkIn:'入住体验',
        cat_cleanliness:'清洁度',
        cat_roomComfort:'客房舒适度',
        cat_breakfast:'早餐',
        cat_diningBar:'餐饮与酒吧',
        cat_facilities:'设施与配套',
        cat_staffService:'员工与服务',
        cat_checkOut:'退房体验',
        reviewsBySubcategory:'子类评论分布',
        colSubcategory:'子类',
        colRatingCount:'Count',
        colReviewCount:'评论数量',
        colScoreShare:'分数占比',
        filterExcellent:'Excellent',
        filterGood:'Good',
        filterAverage:'Average',
        filterBad:'Bad',
        noSubcategoryData:'暂无子类数据',
        reviewDate:'评论日期',
        showMore:'展开',
        showLess:'收起',
        noCommentReviews:'暂无评论',
        metaRoomType:'房型',
        metaCheckIn:'入住',
        metaCheckOut:'离店',
        metaMembership:'会员等级',
    },
    SurveyDetail:{
        pageTitle:'回复列表',
        crumb:'离店后调查 · 单份原始回复（聚合洞察的「原件」，可从 Insights 任一 mention 跳转至此）',
        time24h:'过去 24h',
        timeWeek:'本周',
        timeMonth:'本月',
        filterScoreAll:'全部分数',
        filterScoreLow:'≤6 差评',
        filterScoreMid:'7（中性）',
        filterScoreHigh:'≥8 好评',
        filterStatusAll:'全部状态',
        filterStatusNew:'待处理',
        filterStatusDone:'已读',
        filterTextAll:'有无文本',
        filterTextYes:'含文本',
        filterTextNo:'仅评分',
        responseCount:'{n} 份回复',
        colSubmitted:'提交时间',
        colGuest:'客人',
        colChannel:'渠道',
        colRoom:'房型',
        colNights:'晚数',
        colScore:'总分',
        colRecommend:'推荐',
        colCheckIn:'入住日期',
        colCheckOut:'退房日期',
        colMemberLevel:'会员等级',
        colReplyStatus:'回复状态',
        colText:'文本',
        colStatus:'状态',
        recommendYes:'推荐',
        recommendNo:'NO',
        replyUnreplied:'未回复',
        replyReplied:'已回复',
        textSegments:'{n} 段',
        statusNew:'待处理',
        statusDone:'已读',
        listHint:'点任一行查看完整回复 · 状态「待处理」= 含负面文本或 GM note，需有人跟进',
        backToList:'返回 Responses 列表',
        part1Title:'Part 1 · Overall satisfaction',
        part2Title:'Part 2 · 客人勾选的关注维度 维度评分 + 子项（结构化打分）',
        part3Title:'Part 3 · 客人勾选的其他维度 维度评分 + 子项（结构化打分）',
        overallScoreLabel:'Overall Score',
        solvedLabel:'Solved',
        dimEvaluation:'维度评价',
        notesToManager:'Notes to manager',
        summaryTitle:'Summary',
        prevResponse:'上一个',
        nextResponse:'下一个',
        metaCountry:'Country',
        q1Label:'Q1 · Overall satisfaction',
        q2Label:'Q2 · 客人勾选的关注维度（原始勾选，非抽取）',
        q3Label:'Q3 · 维度评分 + 子项（结构化打分）',
        q4Label:'自由文本 + AI 抽取（可审计层）',
        noAspects:'（未勾选）',
        aiExtraction:'AI 抽取结果',
        sentimentNeg:'负',
        sentimentPos:'正',
        noFailureType:'（正向·无 failure_type）',
        confidence:'置信 {n}%',
        noFreeText:'本份回复无自由文本。',
        submittedAt:'提交于 {ts}',
        metaChannel:'渠道',
        metaRoom:'房型',
        metaNights:'晚数',
        nightsUnit:'{n} 晚',
        metaScore:'总分',
        metaRecommend:'推荐',
        metaExtractions:'文本片段',
        yes:'是',
        no:'否',
        issueResolvedTitle:'问题是否解决',
        issueResolvedYes:'住客称已解决',
        issueResolvedNo:'住客称未解决',
        guestPerceived:'guest-perceived · 非事实',
        gmNoteTitle:'Note to GM（承诺直达）',
        markRead:'标为已读',
        assignFollowUp:'指派跟进',
        waitingForReply:'等待回复',
        aiReplyTitle:'AI 回复',
        aiLangPlaceholder:'选择语言',
        aiTranslation:'翻译',
        aiGenerate:'生成',
        aiEdit:'编辑',
        aiSend:'发送',
        specificReply:'具体回复',
        detailHint:'黄色高亮 = AI 判定为可抽取的片段；右侧 extraction 显示从该句抽出的 failure_type + 维度 + 置信度。registry 未命中落 NEW，不 force-fit。这一页是 AI 抽取的可审计层——Insights 里每个标签都能回溯到此处原句。',
    },
    NeedsAttention:{
        Search_reviews_or_notes: '搜索评论或备注',
        Review_Date: '日期',
        Status: '状态',
        Priority: '优先级',
        Attention: '关注事项',
        More_filters: '更多筛选条件',
        filters: '筛选条件',
        OTA_Source: 'OTA 来源',
        Source: '来源',
        Affected_Areas: '受影响区域',
        Days_since_posted: '发布至今',
        Days: '发布至今',
        OTA_Score: '评分',
        days: '天',
        Reset: '重置',
        Apply: '应用',
        WTK_Score: 'WQI',
        Attention_Reason: '需关注事项',
        'Under Review':'处理中',
        Under_Review: '处理中',
        Open: '未处理',
        Closed: '已关闭',
        Actioned: '已处理',
        All:'全部',
        show_All:'全部',
        High: '高',
        Medium: '中',
        Low: '低',
        AutoAlert: '自动警报',
        Extremely_Negative: '极度负面',
        Rating_Discrepancy: '评分不匹配',
        Negative_Only: '仅负面',
        'Extremely Negative':'极度负面',
        'Rating Discrepancy':'评分不匹配',
        'Negative Only':'仅负面',
        Extremely_Negative_Tip:'OTA评分低于7/10（或3.5/5）',
        Rating_Discrepancy_Tip:'OTA评分与情感评分相差2分以上',
        Negative_Only_Tip:'仅包含负面反馈，无正面评价',
        Total: '总计',
        Key_Metrics: '核心指标',
        Guest_Rating: '客人评分',
        Days_Since: '发布距今',
        Guest_Review: '客人评论',
        Summary: '摘要 / 总结',
        Negative_Summary: '负面摘要',
        Management_Note: '备注',
        Edit: '编辑',
        Action: '跟进操作',
        Save: '保存',
        Show_more: '显示更多',
        Show_Less:'显示更少',
        startTime:'起始',
        endTime:'结束',
        Last_updated_date:'最后更新日期',
        History:'修改记录',
        History_empty:'暂无修改记录',
        History_load_failed:'修改记录加载失败',
        History_retry:'重试',
        History_created:'加入案例管理',
        History_note_cleared:'（已清空）',
        History_remark:'备注',
        No_reviews1:'无活动关注项',
        No_reviews2:'带有需要采取行动的注释的新评论将在此处显示。',
        dialogTitle:'从列表中移除此项',
        dialogText:'这将永久删除该项目及其注释',
        Cancel:'取消',
        Delete:'删除',
        drawerMessage:'Note 不能为空',
        Reply_column:'回复',
        Reply_status:'回复状态',
        Replied:'已回复',
        Not_replied:'未回复',
        Reply_title:'回复内容',
        Reply_date:'回复日期',
        Replied_by:'回复人',
        No_reply_yet:'暂无回复',
        Reply_load_failed:'回复信息加载失败',
        // 手机卡片列表 / 筛选（≤767px）
        Actions:'更多操作',
        View_details:'查看详情',
        No_priority:'不设优先级',
        Remove_filter:'移除筛选条件',
        Reset_all:'全部重置',
        Posted_days:'今天发布 | 发布 1 天 | 发布 {n} 天',
        Load_failed1:'案例加载失败',
        Load_failed2:'请检查网络后重试。',
        No_results1:'没有符合条件的案例',
        No_results2:'试试调整日期范围、搜索词或筛选条件。',
    },
    ReplyLibrary:{
        Search_reviews_or_replies: '搜索评论或回复…',
        Affected_Areas: '涉及领域',
        OTA_Source: 'OTA 来源',
        Sort: '排序',
        Sort_by:'排序方式',
        Time_newest_first: '时间（最新优先）',
        Time_oldest_first: '时间（最早优先）',
        Score: '评分',
        OTA_Score1: 'OTA评分（从高到低）',
        OTA_Score2: 'OTA评分（从低到高）',
        Saved_Reason:'预设原因',
        Use_case:'使用场景',
        tags:'标签',
        Cancel:'取消',
        Save:'保存',
        Discard :'放弃',
        Discard_changes :'放弃更改',
        No_reason_recorded  :'未注明原因',
        No_use_cases_assigned  :'未分配用例',
        You_editing_another_reply:'你正在编辑另一条回复',
        you_tooltip:'在切换之前保存您的更改，或者放弃更改并继续。',
        unLike:'取消收藏',
        No_saved1:'尚未保存任何回复',
        No_saved2:'保存常用回复，构建结构化回复库。',
        // 手机底部弹层（预设原因 / 使用场景）
        Saved_reason_hint:'写下收藏这条回复的原因，方便以后查找和复用。',
        Use_case_hint:'输入场景后按回车添加，可添加多个。',
        Unsaved_changes:'有未保存的修改，确定放弃吗？',
        Keep_editing:'继续编辑',
        Saving:'保存中…',
        Save_failed:'保存失败，请检查网络后重试。',
        Close:'关闭',
    },
    FAQ:{
        needHelp:'需要更多帮助？',
        contactUs:'联系我们',
        searchPlaceholder:'搜索问题…',
        noMatches:'没有匹配的问题',
    },
    Connections:{
        title:'平台连接',
        intro:'把你自己的 Google 商家资料和 Tripadvisor 页面连接到 WhereToKnow。',
        googleDesc:'用拥有或管理该门店 Google 商家资料的 Google 账号登录，然后选择对应的门店。',
        tripadvisorDesc:'搜索该门店的 Tripadvisor 页面，或直接粘贴 Tripadvisor 页面链接。',
        connected:'已连接',
        notConnected:'未连接',
        needsReconnect:'需要重新连接',
        chooseLocationStatus:'待选择门店',
        unavailable:'暂未开放',
        connectGoogle:'连接 Google',
        reconnect:'重新连接',
        chooseLocation:'选择门店',
        changeLocation:'更换门店',
        connectTripadvisor:'连接 Tripadvisor',
        changeListing:'更换页面',
        disconnect:'断开连接',
        viewListing:'查看页面',
        signedInAs:'已登录：{email}',
        chooseGoogleLocation:'选择 Google 门店',
        chooseGoogleLocationHint:'以下是你的 Google 账号管理的商家资料门店。',
        noGoogleLocations:'这个 Google 账号没有管理任何商家资料门店。请用拥有或管理该门店的账号重新连接。',
        searchTripadvisor:'搜索 Tripadvisor',
        searchPlaceholder:'门店名称',
        search:'搜索',
        noResults:'没有找到页面。换个名称试试，或在下方粘贴链接。',
        orPasteLink:'或粘贴你的 Tripadvisor 页面链接',
        connect:'连接',
        cancel:'取消',
        save:'保存',
        disconnectTitle:'断开 {platform}？',
        disconnectBody:'WhereToKnow 将停止使用这个连接，你可以随时重新连接。',
        connectedToast:'已连接 {platform}',
        failed:'出错了，请重试。',
        notEnabled:'该门店尚未开通平台连接，请联系我们开通。',
        notForBrand:'请先选择一家酒店或餐厅，再管理它的平台连接。',
        finishingGoogle:'正在完成 Google 连接…',
        backToConnections:'返回平台连接',
        connectAgain:'重新连接 Google',
        tripadvisorFromProfile: "这是我们采集本门店评论所用的 Tripadvisor 页面。如需换成别的页面，可以在这里更换，WhereToKnow 核对后才会生效。",
        tripadvisorChangePending: "已申请更换为 {name}，WhereToKnow 核对后生效；在此之前仍使用上面的页面。",
        disconnectBodyTripadvisor: "只会断开连接，WhereToKnow 仍会继续采集本门店的 Tripadvisor 评论。你可以随时重新连接。",
        tripadvisorPendingNote:'已提交，WhereToKnow 核对后会确认。',
        pendingStatus:'待确认',
        noMatchingGoogleLocation:'这些商家资料门店都不是 Google 上的「{name}」。请换用管理该门店的 Google 账号登录；如果它就在列表里，请联系我们。',
        useAnotherGoogleAccount:'换一个 Google 账号',
        thisProperty:'本门店',
        promptTitle:'连接你的 Google 商家资料',
        promptBody:'把本门店的 Google 商家资料连到 WhereToKnow，直接对接你的 Google 评论。',
        promptAction:'去连接',
        promptDismiss:'关闭',
        googleCancelled:'已取消 Google 登录。',
        googleFailed:'未能连接 Google，请重试。',
        startAgain:'无法确定这次 Google 登录对应的门店，请重新发起连接。',
    },
    // 读屏用的 aria-label
    A11y:{
        close:'关闭',
        openMenu:'打开菜单',
        scrollLeft:'向左滚动',
        scrollRight:'向右滚动',
        togglePanel:'展开/收起',
    },
    // 右下角帮助聊天气泡（components/common/SupportChatbot.vue）。msg 里的 \n 会被渲染成换行
    SupportChatbot:{
        brandStatus:'在线支持',
        title:'有什么可以帮你？',
        subtitle:'请选择一个主题，或在下方输入你的问题。',
        placeholder:'输入你的问题…',
        privacyPrefix:'使用聊天即表示你同意我们的',
        privacyLink:'隐私政策',
        privacySuffix:'',
        contactTitle:'联系支持团队',
        contactBody:'给我们发一封详细说明的邮件，我们会在 1 个工作日内回复你。',
        noMatch:'抱歉，没能理解你的问题。以下是主要选项：',
        opt:{
            learnFeature:'了解功能',
            contactSupport:'联系支持团队',
            reportIssue:'报告问题',
            wqi:'WQI',
            hotelOverview:'酒店概览',
            hotelCompetitors:'酒店竞品',
            restaurantOverview:'餐厅概览',
            restaurantCompetitors:'餐厅竞品',
            replySetting:'回复设置',
            replyLibrary:'回复库',
            needsAttention:'案例管理',
            reports:'报告',
            brandOverview:'品牌概览',
            staffLeaderboard:'员工提及排行榜',
            settings:'设置、目标与通知',
            backToMain:'返回主菜单',
            gotIt:'明白了',
            needMoreHelp:'我需要更多帮助',
            back:'返回',
            adjustCompSet:'我想调整竞品组',
            dataMissing:'数据加载不出来或缺失',
            crashError:'崩溃、报错或显示异常',
            resolvedIt:'问题解决了',
            stillMissing:'仍然缺失 —— 发邮件给支持团队',
            emailSupport:'发邮件给支持团队',
            anotherQuestion:'有，还有别的问题',
            thatsAll:'没有了，就这些',
            helpful:'有帮助',
            notReally:'没什么帮助',
        },
        msg:{
            start:'今天有什么可以帮你？',
            featureHelp:'你想了解哪个功能？',
            reportBug:'给你带来不便，非常抱歉。你遇到的是哪类问题？',
            bugData:'如果数据缺失或没有更新，请尝试：\n\n1. 查看“最后更新”时间 —— 数据每 2–4 小时刷新一次\n2. 换一个时间范围\n3. 强制刷新页面（Ctrl+Shift+R / Cmd+Shift+R）\n\n如果 4 小时后数据仍然缺失，我们的团队可以帮你排查。',
            bugOther:'为了帮助我们解决问题，请发邮件告诉我们：\n\n• 出问题的页面或模块\n• 出问题前你做了什么操作\n• 你预期的结果和实际发生的情况\n• 如有可能，附上截图',
            connectHuman:'我们的支持团队很乐意为你提供帮助，通常会在 1 个工作日内回复。',
            resolved:'很高兴能帮到你。还有其他问题吗？',
            feedback:'离开前想问一下 —— 这次对话对你有帮助吗？',
            feedbackPositive:'感谢你的反馈，祝你愉快！',
            feedbackNegative:'感谢你的坦诚。你可以直接联系我们的支持团队，他们很乐意帮忙：',
            library:'回复库是你收藏的评论回复合集。\n\n• 点击任意回复上的爱心图标即可收藏\n• 每条收藏会保存原始评论、你的回复、OTA 来源、评分和涉及的方面\n• 添加“收藏原因”和“使用场景”标签来整理收藏\n• 收藏的回复、原因和标签随时可以编辑\n• 可按日期、OTA 来源、涉及方面筛选，或按关键词搜索',
            reports:'报告：\n\n• 可选周期：周报、月报、季报、半年报和年报\n• 每份报告包含各类别评分、趋势概览、管理重点，以及可直接分发给各部门的行动计划\n• 周报每周一更新；月报每月 1 日更新\n• 数据可靠性指示：绿色 = 50 条以上评论（可信度高），黄色 = 10–50 条，红色 = 少于 10 条\n• 使用“上一期” / “下一期”按钮在不同周期之间对比',
            hotel:{
                wqi:'WQI 是由 AI 生成的评分（1–10），基于你所有评论平台上真实的宾客情感。\n\n它不是简单的平均分，而是分析每条评论的完整文本和情感强度，覆盖 7 个类别：服务、清洁、客房、餐饮、设施、位置和性价比。\n\n分数区间：\n• 9–10：卓越\n• 8–9：很好\n• 7–8：良好\n• 6–7：需要改进\n• 6 分以下：需立即关注',
                dashboard:'酒店概览一览：\n\n• 数据每 2–4 小时自动刷新\n• 使用平台标签（Booking.com、Google、Expedia…）按来源筛选\n• 点击任意 KPI 圆环，可深入查看子类别和单条评论\n• 员工提及排行榜显示宾客提到了哪些员工，以及评价是正面还是负面\n• 餐饮提及排行榜汇总评论中关于餐饮的亮点',
                competitors:'酒店竞品：\n\n• 初始竞品组由 WTK 根据位置、档次、价格区间和客群重合度搭建\n• 你可以随时申请调整竞品组，更新需要 24–48 小时\n• 标准版：5 家竞品 · 专业版：最多 10 家 · 企业版：自定义\n• 所有竞品数据均来自公开的 OTA 和评论平台',
                reply:'回复设置：\n\n• 选择品牌预设（正式优雅、高端温暖、轻松活泼、简约中性）来确定回复语气\n• 调整正式程度、缩写、表情符号和幽默等开关，使回复符合品牌风格\n• 语言可设为自动（用宾客的语言回复）或固定语言\n• 使用智能回复，在评论提到特定话题时自动插入自定义语句\n• 设置回复长度：简短（30–60 词，适合 OTA）、标准、详细或动态',
                attention:'案例管理通过 AI 风险信号自动标记需要立即处理的评论。\n\n每条被标记的评论都会显示“自动提醒”标签，以及最多两个风险信号标签：\n• 评分与体验不符 —— OTA 评分与 WTK 分析结果差距较大\n• 极度负面 —— 多个类别都有强烈的负面情绪\n• 纯负面评论 —— 完全没有正面内容\n\n每条评论都可以设置优先级（高 / 中 / 低）、更新状态（待处理 → 已处理 → 已关闭），并添加管理备注。发布后的天数按颜色区分：绿色（≤3 天）、橙色（3–5 天）、红色（>5 天）。',
                brand:'品牌概览提供整个酒店集团的多门店洞察。\n\n• 全球与区域排名 —— 查看每家酒店在品牌内的表现\n• 会员等级表现 —— 不同会员等级对入住体验的评价\n• 品牌一致性与表达 —— 追踪品牌契合度、在地文化表达、创新和推荐意愿\n• 使用地图视图和区域选择器浏览各门店',
                settings:'设置、目标与通知：\n\n• 为 7 个 KPI 类别分别设置目标分，看板会实时显示差值 = 实际 – 目标\n• 目标可随时调整，按门店分别设置\n• 通知：可开启 OTA 评分提醒（按平台设置阈值）和 AI 风险信号提醒（评分与体验不符、纯负面评论）的邮件通知\n• 携程默认满分 10 分，中文界面下按 5 分制显示\n• 在“通知接收人”中可以添加多个邮箱\n• 登录邮箱无法在设置中修改，请联系管理员或我们的支持团队',
            },
            restaurant:{
                wqi:'WQI 是由 AI 生成的评分（1–10），基于你所有评论平台上真实的宾客情感。\n\n它不是简单的平均分，而是分析每条评论的完整文本和情感强度，覆盖 7 个类别：菜品质量、员工服务、氛围、清洁、性价比、过敏原处理和整体体验。\n\n分数区间：\n• 9–10：卓越\n• 8–9：很好\n• 7–8：良好\n• 6–7：需要改进\n• 6 分以下：需立即关注',
                dashboard:'餐厅概览一览：\n\n• 数据每 2–4 小时自动刷新\n• 使用平台标签（Booking.com、Google、TripAdvisor…）按来源筛选\n• 点击任意 KPI 圆环，可深入查看子类别和单条评论\n• 员工提及排行榜显示顾客提到了哪些员工，以及评价是正面还是负面\n• 从顾客反馈中追踪菜品亮点、特殊需求和饮食偏好',
                competitors:'餐厅竞品：\n\n• 初始竞品组由 WTK 根据菜系、位置、价格区间和客群重合度搭建\n• 你可以随时申请调整竞品组，更新需要 24–48 小时\n• 所有竞品数据均来自公开的 OTA 和评论平台',
                reply:'回复设置：\n\n• 选择品牌预设来确定回复语气（专业、温暖、轻松、简约）\n• 调整正式程度、缩写、表情符号和幽默等开关，使回复符合品牌风格\n• 语言可设为自动（用顾客的语言回复）或固定语言\n• 使用智能回复，在评论提到菜系、过敏原或服务等话题时自动插入自定义回复\n• 设置回复长度：简短（30–60 词）、标准、详细或动态',
                attention:'案例管理通过 AI 风险信号自动标记需要立即处理的评论。\n\n每条被标记的评论都会显示“自动提醒”标签，以及最多两个风险信号标签：\n• 评分不匹配 —— OTA 评分与 WTK 分析结果差距较大\n• 极度负面 —— 多个类别都有强烈的负面情绪\n• 纯负面评论 —— 完全没有正面内容\n\n每条评论都可以设置优先级（高 / 中 / 低）、更新状态，并添加管理备注。',
                staff:'员工提及排行榜：\n\n• 自动追踪顾客评论中提到的员工\n• 显示提及次数、情感倾向（正面 / 负面）和关键反馈\n• 帮助发现表现突出的员工，表彰优质服务\n• 通过排行榜了解哪些员工对顾客满意度影响最大\n• 可按时间范围和 OTA 来源筛选',
                settings:'设置、目标与通知：\n\n• 为 7 个 KPI 类别分别设置目标分，看板会实时显示差值 = 实际 – 目标\n• 目标可随时调整，按餐厅分别设置\n• 通知：可开启 OTA 评分提醒和 AI 风险信号提醒的邮件通知\n• 在“通知接收人”中可以添加多个邮箱\n• 登录邮箱无法在设置中修改，请联系管理员或我们的支持团队',
            },
        },
    },
}
